export const jobs = {
  // The job page, top down (tracker sj-30).
  page: {
    state: {
      done: "Terminé",
      current: "Vous êtes ici",
      upcoming: "Plus tard",
    },
    youAreHere: "Vous êtes ici",
    nextStep: {
      title: "Étape suivante",
      needsYou: "Vous attend",
      changeStatusA11y: "Statut : {{status}}. Changer le statut",
      giveToSomeoneElse: "Confier à quelqu’un d’autre",
      nothingLeft: "Plus rien à faire",
    },
    section: {
      what: "À faire",
      where: "Où",
      who: "Qui et quand",
      before: "Avant de commencer",
      beforeAny: "Avant le début de tout sous-travail",
      work: "Le travail",
      subJobs: "Sous-travaux",
      costs: "Coûts",
      finish: "À la fin du travail",
      atTheEnd: "À la fin",
      signOff: "Validation",
      report: "Rapport",
      activity: "Activité",
    },
    change: "Modifier",
    openReport: "Ouvrir le rapport",
    meta: {
      doneOf: "{{done}} sur {{total}}",
      updates_one: "1 mise à jour",
      updates_many: "{{count}} mises à jour",
      updates_other: "{{count}} mises à jour",
      estimate: "env. {{amount}}",
    },
    summary: {
      nobodyYet: "Personne pour l’instant",
      workDone: "Travail terminé",
      signedOff: "Validé",
      waitingSignOff: "En attente de validation",
      reportLater: "Prêt une fois le travail terminé",
      costsLater: "Ajoutés une fois le travail commencé",
      noCosts: "Aucun coût enregistré",
      signOffLater: "Une fois le travail terminé",
    },
  },
  visits: {
    showMe: "Montrez-moi",
    title: "Visites",
    empty: "Une visite pour l'instant. Planifiez une autre visite si le travail demande plus d'un jour.",
    visitNo: "Visite {{no}}",
    arrive: "Je suis sur place",
    arrived: "Arrivée enregistrée",
    move: "Déplacer la visite",
    moveTitle: "Déplacer la visite {{no}}",
    moved: "Visite déplacée",
    notes: "Notes du jour",
    notesTitle: "Notes de la visite {{no}}",
    notesMessage: "Qu'est-ce qui a été fait lors de cette visite ?",
    notesSaved: "Notes enregistrées",
    cancel: "Annuler la visite",
    cancelled: "Visite annulée",
    add: "Planifier une visite",
    addAnother: "Planifier une autre visite",
    addTitle: "Planifier une visite",
    addHint: "La même personne revient un autre jour. Le travail se termine une seule fois, à la fin.",
    added: "Visite planifiée",
    comeBack: "Je dois revenir",
    comeBackTitle: "Je dois revenir",
    comeBackHint: "La visite du jour s'arrête ici et la suivante est planifiée. Le travail reste ouvert.",
    comeBackReason: "Pourquoi devez-vous revenir ?",
    todayNotes: "Ce qui a été fait aujourd'hui (facultatif)",
    nextDay: "Prochaine visite",
    comeBackConfirm: "Planifier la prochaine visite",
    comeBackSaved: "Prochaine visite planifiée",
    comeBackBecause: "Retour prévu : {{reason}}",
    day: "Jour",
    time: "Heure",
    save: "Enregistrer",
    cancelSheet: "Annuler",
    photosHint: "Ajoutez les photos d'une visite à l'activité du travail le jour même.",
    failedTitle: "Impossible de mettre à jour les visites",
    failedBody: "Veuillez réessayer.",
    count_one: "{{count}} visite",
    count_many: "{{count}} visites",
    count_other: "{{count}} visites",
    status: {
      planned: "Planifiée",
      arrived: "Sur place depuis {{time}}",
      done: "Terminée",
      cancelled: "Annulée",
    },
  },
  subJobs: {
    title: "Sous-travaux",
    progress: "{{done}} sur {{total}} terminés",
    toCheck: "{{n}} à vérifier",
    empty: "Découpez ce travail en tâches plus petites, chacune avec sa personne et sa date. Ce travail attend qu'elles soient toutes terminées.",
    add: "Ajouter un sous-travail",
    inOrder: "Les faire dans l'ordre",
    partOf: "Fait partie de {{title}}",
    partOfUnknown: "Fait partie d'un travail plus grand",
    unassigned: "Pas encore attribué",
    waiting: "Attend le précédent",
    waitsFor: "Attend que « {{title}} » soit terminé.",
    cost: "Coût des sous-travaux à ce jour : {{amount}}",
    created: "Sous-travail ajouté",
    sheetTitle: "Ajouter un sous-travail",
    orderFailedTitle: "Impossible de changer l'ordre",
    orderFailedBody: "Vérifiez votre connexion et réessayez.",
    asOneJob: "En faire un seul travail avec des sous-travaux",
    asOneJobHint: "Un travail regroupe les {{n}}, chacun avec sa personne et sa date. Il se ferme quand tous sont terminés.",
    parentTitle: "Corriger les constats sur {{asset}}",
    parentTitleNoAsset: "Corriger les constats d'inspection",
    parentBrief: "Regroupe {{n}} sous-travaux, un par constat. Il attend qu'ils soient tous terminés.",
    openBlocksComplete_one: "1 sous-travail est encore ouvert. Terminez-le ou annulez-le avant de terminer ce travail.",
    openBlocksComplete_many: "{{count}} sous-travaux sont encore ouverts. Terminez-les ou annulez-les avant de terminer ce travail.",
    openBlocksComplete_other: "{{count}} sous-travaux sont encore ouverts. Terminez-les ou annulez-les avant de terminer ce travail.",
    family: {
      status: {
        cancelled: "Annulé",
        signed_off: "Validé",
        needs_you: "Vous attend",
        ready_to_sign_off: "Prêt à valider",
        in_progress: "En cours",
        scheduled: "Planifié",
        waiting: "En attente",
      },
      needs: {
        over_budget: "Les coûts des sous-travaux dépassent le budget du travail.",
        declined: "Un sous-travail a été refusé. Confiez-le à quelqu'un d'autre pour que le travail avance.",
        cant_complete: "Quelqu'un ne peut pas faire son sous-travail comme prévu. Décidez-en sur le sous-travail.",
        sent_back: "Un sous-travail a été renvoyé et est en cours de reprise.",
        late: "Un sous-travail est en retard. Relancez, réattribuez ou déplacez-le.",
      },
      runBy: "Piloté par {{name}}",
      runByNobody: "Personne ne pilote encore ce travail",
      changeOwner: "Changer qui le pilote",
      budget: "Budget {{budget}} · à ce jour {{spent}}",
      overBudget: "Budget dépassé de {{amount}}",
      forecast: "Fin prévue {{date}}",
      due: "Échéance {{date}}",
      checked: "Vérifié",
      needsCheck: "Terminé : à vérifier",
      waitsForList: "Attend {{titles}}",
      late: "En retard",
      showAll: "Afficher les {{total}}",
      showFewer: "Afficher moins",
      check: "Vérifier le travail",
      checkedToast: "Travail vérifié",
      youAreHere: "Vous êtes ici",
      stepOf: "Sous-travail {{n}} sur {{total}}",
      previous: "Précédent",
      next: "Suivant",
      menu: {
        title: "{{title}}",
        open: "Ouvrir",
        start: "Démarrer",
        schedule: "Planifier",
        reassign: "Réattribuer",
        remind: "Relancer",
        pause: "Mettre en pause",
        skip: "Passer, avec un motif",
        check: "Vérifier le travail",
        sendBack: "Renvoyer",
        askPhotos: "Demander des photos",
        waitsFor: "Ce qu'il attend",
        separate: "En faire un travail séparé",
        moveTo: "Déplacer vers un autre travail",
        run: "Piloter",
        review: "Vérifier",
        family: "Travail",
      },
      reminded: "Relance envoyée",
      remindedAlready: "Rien à relancer : il est terminé ou personne n'y est affecté.",
      skipTitle: "Passer ce sous-travail ?",
      skipMessage: "Il compte comme fait pour le travail et n'apparaît jamais comme un travail réalisé.",
      skipPlaceholder: "Pourquoi n'est-il pas nécessaire ?",
      skipConfirm: "Le passer",
      skipped: "Sous-travail passé",
      sendBackTitle: "Renvoyer",
      sendBackMessage: "Indiquez ce qui doit être repris. {{name}} est prévenu, et le travail est de nouveau vérifié une fois terminé.",
      sendBackPlaceholder: "Que faut-il reprendre ?",
      sendBackConfirm: "Renvoyer",
      sentBack: "Renvoyé",
      askPhotosTitle: "Demander des photos",
      askPhotosMessage: "Indiquez ce que vous devez voir. Il reste terminé pendant que {{name}} les ajoute.",
      askPhotosPlaceholder: "Que devez-vous voir ?",
      askPhotosConfirm: "Demander",
      asked: "Photos demandées",
      pausePlaceholder: "Pourquoi en pause ?",
      pauseTitle: "Mettre ce sous-travail en pause ?",
      pauseConfirm: "Mettre en pause",
      paused: "En pause",
      separateTitle: "En faire un travail séparé ?",
      separateMessage: "Il quitte ce travail et garde sa personne, ses dates et son historique. Ce travail ne l'attend plus.",
      separateConfirm: "Le séparer",
      separated: "C'est désormais un travail séparé",
      signOff: "Valider tout le travail",
      signOffHint_one: "Valide ce travail et son sous-travail terminé ensemble.",
      signOffHint_many: "Valide ce travail et ses {{count}} sous-travaux terminés ensemble.",
      signOffHint_other: "Valide ce travail et ses {{count}} sous-travaux terminés ensemble.",
      signOffFor: "Prêt à être validé par {{name}}.",
      signedOff: "Travail validé",
      approvalEach: "Je vérifie chaque sous-travail dès qu'il est terminé",
      approvalEachHint: "Le suivant ne démarre qu'après votre vérification. Désactivé : l'approbateur vérifie tout une seule fois, à la validation.",
      moveAll: "Déplacer toutes les dates",
      moveAllTitle: "Déplacer les sous-travaux ouverts",
      moveAllMessage: "De combien de jours ? Mettez un signe moins pour les avancer.",
      moveAllConfirm: "Déplacer",
      movedDates_one: "1 sous-travail déplacé",
      movedDates_many: "{{count}} sous-travaux déplacés",
      movedDates_other: "{{count}} sous-travaux déplacés",
      moveDaysInvalid: "Saisissez un nombre entier de jours, par exemple 2 ou -1.",
      cancelAll: "Annuler tout le travail",
      cancelAllTitle: "Annuler tout le travail ?",
      cancelAllMessage: "Le travail et tous les sous-travaux non terminés sont annulés, et leurs personnes sont prévenues. Le travail terminé garde son historique.",
      cancelAllPlaceholder: "Pourquoi ? (facultatif)",
      cancelAllConfirm: "Annuler le travail",
      cancelledAll_one: "Travail annulé avec 1 sous-travail ouvert",
      cancelledAll_many: "Travail annulé avec {{count}} sous-travaux ouverts",
      cancelledAll_other: "Travail annulé avec {{count}} sous-travaux ouverts",
      more: "Plus pour ce travail",
      failedTitle: "Impossible de faire cela",
      failedBody: "Vérifiez votre connexion et réessayez.",
      waitsForTitle: "Qu'attend « {{title}} » ?",
      waitsForNone: "Rien : il peut démarrer à tout moment",
      waitsForSaved: "Enregistré",
      addExisting: "Ajouter un travail existant",
      addExistingTitle: "Ajouter un travail existant",
      addExistingEmpty: "Aucun travail ouvert sur ce site ne peut être ajouté.",
      added: "Ajouté à ce travail",
      moveToTitle: "Vers quel travail ?",
      moveToEmpty: "Aucun autre travail ouvert sur ce site.",
      movedTo: "Déplacé",
      planTitle: "Planifier les sous-travaux",
      planHint: "Le travail lui-même se fait dans les sous-travaux. Ce travail se clôt quand ils sont tous faits{{checked}}.",
      planHintChecked: " et vérifiés",
      slipTitle_one: "Déplacer le sous-travail qui attend celui-ci ?",
      slipTitle_many: "Déplacer les {{count}} sous-travaux qui attendent celui-ci ?",
      slipTitle_other: "Déplacer les {{count}} sous-travaux qui attendent celui-ci ?",
      slipMessage_one: "Celui-ci a bougé de 1 jour {{direction}}. Déplacez-les d'autant pour garder l'ordre.",
      slipMessage_many: "Celui-ci a bougé de {{count}} jours {{direction}}. Déplacez-les d'autant pour garder l'ordre.",
      slipMessage_other: "Celui-ci a bougé de {{count}} jours {{direction}}. Déplacez-les d'autant pour garder l'ordre.",
      later: "plus tard",
      earlier: "plus tôt",
      budgetSet: "Fixer un budget",
      budgetMessage: "Les coûts des sous-travaux s'y imputent ; vous êtes prévenu en cas de dépassement. Saisissez 0 pour le retirer.",
      budgetConfirm: "Enregistrer",
      budgetInvalid: "Saisissez un montant, par exemple 2500.",
      budgetSaved: "Budget enregistré",
      timeline: {
        today: "Aujourd'hui",
        forecast: "Fin prévue",
        undated_one: "1 sous-tâche n'a pas encore de date",
        undated_many: "{{count}} sous-tâches n'ont pas encore de date",
        undated_other: "{{count}} sous-tâches n'ont pas encore de date",
      },
      activityFromSubJobs: "Des sous-tâches",
      activityLabel: "Sous-tâche {{n}} : {{title}}",
      addToThisJob: "Ajouter à ce travail",
      separateJob: "Travail séparé",
      addedToThisJob: "Ajouté comme sous-tâche suivante",
      extraWaiting: "Travail supplémentaire en attente de votre décision : {{title}}",
      sentToRequester: "Envoyé au demandeur pour confirmation. Validez après son accord.",
      waitsForRequester: "Le demandeur confirme d'abord tout le travail, puis vous le validez.",
      template: {
        use: "Ajouter des sous-tâches depuis un modèle",
        save: "Enregistrer comme modèle",
        saveMessage: "Enregistre ces sous-tâches, leur ordre et ce qui attend quoi. Les personnes, dates et coûts ne sont pas conservés.",
        saveConfirm: "Enregistrer le modèle",
        saved: "Enregistré sous « {{name}} »",
        pickTitle: "Modèles",
        manage: "Gérer",
        delete: "Supprimer « {{name}} »",
        deleted: "Modèle supprimé",
        empty: "Aucun modèle pour l'instant. Enregistrez d'abord un travail avec sous-tâches comme modèle.",
        row_one: "{{name}} · 1 étape",
        row_many: "{{name}} · {{count}} étapes",
        row_other: "{{name}} · {{count}} étapes",
        applied_one: "1 sous-tâche ajoutée",
        applied_many: "{{count}} sous-tâches ajoutées",
        applied_other: "{{count}} sous-tâches ajoutées",
      },
      showMe: "Montrez-moi",
      mainContractor: {
        handOver: "Confier à une entreprise principale",
        takeBack: "Reprendre le travail",
        takeBackTitle: "Reprendre le travail ?",
        takeBackMessage: "{{name}} ne pilote plus ce travail et vous le pilotez à nouveau. Les sous-travaux déjà attribués restent à ceux qui les ont.",
        takenBack: "Vous pilotez de nouveau ce travail",
        pickTitle: "Quelle entreprise pilote ce travail ?",
        allowTitle: "{{name}} peut-elle aussi faire appel à vos prestataires ?",
        allowYes: "Oui, elle peut confier des sous-travaux à nos prestataires",
        allowNo: "Non, seulement son propre personnel",
        handedOver: "{{name}} pilote maintenant ce travail",
        youRunIt: "Vous pilotez ce travail pour le client. Ajoutez des sous-travaux pour votre équipe ; le client valide à la fin.",
        runsIt: "Une entreprise principale pilote ce travail. Vous validez à la fin.",
        nameCrew: "Nommer l'équipe",
        nameCrewMessage: "Qui de votre équipe fait ce sous-travail ? Le client voit le nom.",
        nameCrewConfirm: "Enregistrer",
        crewSaved: "Équipe enregistrée",
        crewPlaceholder: "Par exemple : Lee",
        subJobTitle: "Ce qu'il faut faire",
        brief: "Description (facultatif)",
        when: "Quand",
        who: "Qui le fait",
        ourCrew: "Notre équipe",
        crewName: "Équipe ou personne",
        clientContractorHint: "Le prestataire du client reçoit le sous-travail et ses propres rappels.",
        addAnother: "Ajouter et suivant",
      },
      report: {
        summary: "Résumé",
        full: "Complet",
        internal: "Interne",
        forClient: "Pour le client",
        forClientHint: "Pour le client : sans tarifs ni prix des sous-traitants.",
        partOf: "Fait partie de",
        checked: "Vérifié",
        checkedBy: "Vérifié par {{name}}",
        started: "Commencé {{date}}",
        finished: "Terminé {{date}}",
        evidence_one: "1 photo ou fichier",
        evidence_many: "{{count}} photos ou fichiers",
        evidence_other: "{{count}} photos ou fichiers",
      },
      parts: {
        title: "Pièces pour tout le travail",
        missing_one: "1 pas encore là",
        missing_many: "{{count}} pas encore là",
        missing_other: "{{count}} pas encore là",
        allInHand: "Tout est là",
        holdsUp: "Bloque {{title}}",
      },
      plan: {
        asset: "Équipement",
        priority: "Priorité",
        estimate: "Estimation",
        minutes: "Durée (minutes)",
        waitsFor: "Attend",
        copyFrom: "Copier d'un travail passé",
        addAnother: "Ajouter, puis un autre",
        create: "Créer la sous-tâche",
        minutesOther: "Autre durée (minutes)",
        done: "Terminé",
        addedCount_one: "1 sous-travail ajouté",
        addedCount_many: "{{count}} sous-travaux ajoutés",
        addedCount_other: "{{count}} sous-travaux ajoutés",
      },
      setup: {
        title: "Qui pilote ce travail ?",
        hint: "Le pilote planifie les sous-travaux, vérifie chacun dès qu'il est terminé et fait avancer le travail.",
        me: "Moi",
        current: "{{name}} (en charge actuellement)",
        someoneElse: "Quelqu'un d'autre",
        keepOwnWork: "Garder le travail déjà prévu sur ce travail comme sous-travail 1",
        keepOwnWorkHint: "{{name}} garde ce travail et doit l'accepter de nouveau comme sous-travail.",
        continue: "Continuer",
      },
    },
  },
detail: {
  handoffLock: {
    assignee: "Confiée à {{name}}. L’intervention reste telle que définie ; réattribuez-la ou reprenez-la pour la modifier.",
    quotes: "Chez des prestataires pour devis. L’intervention reste telle que définie ; choisissez un devis ou fermez la demande pour la modifier.",
    changeTheWork: "Modifier l’intervention",
    changing: "Vous modifiez cette intervention. {{name}} a été prévenu et devra l’accepter à nouveau quand vous aurez terminé.",
    doneChanging: "Terminer la modification",
    beingChangedBy: "{{name}} modifie cette intervention.",
    changedSinceAccepted: "Cette intervention a changé depuis que vous l’avez acceptée. Vérifiez-la, puis acceptez-la à nouveau.",
    revisedLength: "Combien de temps faut-il maintenant ? (minutes)",
    opened: "Modification ouverte. {{name}} a été prévenu.",
    closed: "Modification terminée. {{name}} doit accepter l’intervention révisée.",
  },
  report: {
    sharePrepared: "{{title}} est prêt.",
    shareSheetProviderHint: "Choisissez {{provider}} dans le menu de partage pour enregistrer ce fichier.",
    share: {
      word: "Partager le Word…",
      excel: "Partager l’Excel…",
      pdf: "Partager le PDF…",
    },
    requestFailed: "Cela n’a pas fonctionné. Vérifiez votre connexion et réessayez.",
    exportFailed: "Le fichier du rapport n’a pas été créé. Vérifiez votre connexion et réessayez.",
    exportShared: "Rapport prêt. Il a été transmis au menu de partage pour l’enregistrer ou l’envoyer.",
    exportDownloadStarted: "Le téléchargement a commencé. Retrouvez-le dans vos téléchargements.",
    exportTitle: "Rapport de fin d’intervention ({{format}})",
    brandingSettings: "Paramètres de marque",
    openJob: "Ouvrir l’intervention",
    linkCopied: "Lien de vérification copié. Collez-le dans un e-mail ou un message.",
    shareToGetLink: "Partagez le rapport pour obtenir un lien",
    copyReviewLink: "Copier le lien de vérification",
    reviewRequested: "vérification demandée",
    sharedWith: "Partagé avec {{name}}",
    sharedReport: "Rapport de fin partagé",
    signedBy: "Signé par {{name}}",
    forYourRecords: "Ce rapport est pour vos archives.",
    alreadyClosed: "Cette intervention est déjà clôturée.",
    sentBackMessage: "Vous avez renvoyé le travail. L’équipe va le corriger et repartager le rapport.",
    acceptedThanks: "Vous avez accepté le travail. Merci.",
    acceptedTeamCloses: "Vous avez accepté le travail. L’équipe va maintenant clôturer l’intervention.",
    sendBack: "Renvoyer",
    acceptWork: "Valider",
    signOffPrompt: "Parcourez le travail ci-dessus. S’il vous convient, signez pour valider. Sinon, touchez Renvoyer et dites ce qui doit être corrigé.",
    decisionFailedBody: "Vérifiez votre connexion et réessayez.",
    decisionFailedTitle: "Votre réponse n’a pas été envoyée",
    sentBackToast: "Renvoyé. L’équipe a été prévenue de ce qui doit être corrigé.",
    acceptedToast: "Merci. L’équipe a été prévenue que le travail vous convient.",
  },
  contextCard: {
    untitledJob: "Intervention sans titre",
    created: "Créée",
    createdBy: "Créée par {{name}}",
    showFewerDetails: "Afficher moins de détails",
    showMoreDetails: "Afficher plus de détails",
    fewerDetails: "Moins de détails",
    moreDetails: "Plus de détails",
    dueAndScheduled: "À faire pour le {{due}} · prévue le {{scheduled}}",
    scheduled: "Prévue le {{scheduled}}",
    due: "À faire pour le {{due}}",
    contacts: "Contacts",
    when: "Quand",
    why: "Pourquoi",
    what: "Quoi",
    where: "Où",
    asset: "Actif",
  },
  actionSheets: {
    failedToAskForPhotos: "Votre demande de photos n’a pas été envoyée. Vérifiez votre connexion et réessayez.",
    failedToSendBack: "L’intervention n’a pas été renvoyée. Vérifiez votre connexion et réessayez.",
    failedToDecline: "L’intervention n’a pas été refusée. Vérifiez votre connexion et réessayez.",
    failedToCancel: "L’intervention n’a pas été annulée. Vérifiez votre connexion et réessayez.",
    failedToPause: "L’intervention n’a pas été suspendue. Vérifiez votre connexion et réessayez.",
    askedForPhotosUnnamed: "Photos supplémentaires demandées. L’intervention attend votre vérification.",
    askedForPhotos: "Photos supplémentaires demandées à {{assignee}}. L’intervention attend votre vérification.",
    sentBackUnnamed: "Renvoyée avec votre note. Vous serez prévenu quand elle sera soumise à nouveau.",
    sentBack: "Renvoyée à {{assignee}} avec votre note. Vous serez prévenu quand elle sera soumise à nouveau.",
    declined: "Intervention refusée. La personne qui l’a attribuée a été prévenue et peut la réattribuer.",
    cancelled: "Intervention annulée. Elle reste dans l’historique.",
    paused: "Intervention suspendue. Touchez Reprendre quand le travail peut continuer.",
  },
  fieldAssist: {
    failedTitle: "Impossible d’améliorer ce texte",
    revert: "Rétablir",
    discard: "Ignorer",
    accept: "Accepter",
    rationale: "Vérifiez le texte, puis touchez Accepter. Votre texte reste en place d’ici là.",
    draftTitle: "Texte amélioré",
    tidying: "Amélioration…",
    tidyUp: "Améliorer avec l’IA",
    stop: "Arrêter",
    dictate: "Dicter",
  },
  deliveryMode: {
    hint: {
      PRIVATE_QUOTES: "Demandez un prix à quelques prestataires, puis choisissez-en un.",
      DIRECT_CONTRACTOR: "Envoyez-la à un prestataire que vous connaissez déjà.",
      INTERNAL: "Une personne de votre équipe fait le travail.",
    },
    label: {
      PRIVATE_QUOTES: "Demander des devis",
      DIRECT_CONTRACTOR: "Un prestataire",
      INTERNAL: "Notre équipe",
    },
    title: "Qui s’en charge ?",
  },
title: "Intervention",
actionModals: {
  send: "Envoyer",
pauseReasons: {
waitingOnParts: "En attente de pièces",
weatherDelay: "Retard météo",
customerRequest: "Demande du client",
other: "Autre",
},
declineReasons: {
scheduleConflict: "Conflit d'horaire",
noCapacity: "Trop occupé en ce moment",
wrongTrade: "Nécessite une autre compétence",
needMoreInfo: "Besoin de plus d'informations",
},
pauseTitle: "Suspendre l'intervention",
pauseReasonRequiredHint: "Un motif est requis pour que l'équipe sache pourquoi le travail est suspendu.",
additionalDetailOptional: "Détail supplémentaire (facultatif)",
additionalDetailPlaceholder: "par ex. Retour en stock prévu la semaine prochaine",
cancel: "Annuler",
pause: "Mettre en pause",
cancelJobTitle: "Annuler l'intervention",
cancelJobConfirm: "Êtes-vous sûr ? Cette action est irréversible.",
reasonOptional: "Motif (facultatif)",
cancellationReasonPlaceholder: "par ex. Plus nécessaire",
back: "Retour",
yesCancel: "Oui, annuler",
declineJobTitle: "Refuser l’intervention",
declineReasonRequiredHint: "Un motif est requis. La personne qui a attribué cette intervention sera avisée.",
reasonRequired: "Motif (obligatoire)",
declineReasonPlaceholder: "par ex. Conflit d’horaire, capacité, autre engagement",
additionalNoteOptional: "Note complémentaire (facultatif)",
additionalNotePlaceholder: "Toute précision pour la personne qui a attribué l’intervention",
declineJob: "Refuser",
reworkTitle: "Renvoyer",
reworkHint: "Indiquez ce qui doit être corrigé. La personne qui a fait le travail voit votre note et le renvoie pour vérification une fois corrigé.",
reworkReasonPlaceholder: "par ex. Photos manquantes pour X, coût réel non renseigné, notes peu claires",
evidenceTitle: "Demander des photos",
evidenceHint: "Indiquez ce que vous devez voir. L’intervention reste en vérification chez vous pendant l’ajout des photos.",
evidenceReasonPlaceholder: "p. ex. Une photo nette de la zone de fixation inférieure",
requestEvidence: "Demander des photos",
rework: "Renvoyer",
},
detailScreen: {
  followUpNeeded: "Suivi nécessaire : {{reason}}.",
  receiptsAndInvoices: "Reçus et factures",
  verifyInTheirPlace: "Vérifier à sa place",
  completedSolo: "C’est fait. L’intervention est clôturée.",
  assignedInviteFailedBody: "L’intervention lui est attribuée, mais l’e-mail d’invitation n’a pas pu partir. Prévenez cette personne vous-même.",
  assignedInviteFailedTitle: "Attribué, mais l’e-mail n’est pas parti",
  noTeamBody: "Impossible de savoir à quelle équipe appartient cette intervention ; le prestataire n’a pas été invité. Vérifiez votre connexion et réessayez.",
  noTeamTitle: "Aucune équipe pour cette intervention",
  failedToResume: "L’intervention n’a pas repris. Vérifiez votre connexion et réessayez.",
  failedToAssign: "L’intervention n’a pas été attribuée. Vérifiez votre connexion et réessayez.",
addTitleFirst: "Ajouter d'abord un titre",
addDescriptionFirst: "Ajoutez d'abord une description",
typeOrDictateTitleHint: "Tapez ou dictez un titre court, puis utilisez Améliorer avec l'IA.",
typeOrDictateDescriptionHint: "Tapez ou dictez une description, puis utilisez Améliorer avec l'IA.",
unableToImproveText: "Impossible d'améliorer le texte",
tryAgain: "Veuillez réessayer.",
verifiedInPlaceOf: "Vérifié à la place de {{name}}",
couldNotVerify: "Impossible de vérifier",
tryAgainShort: "Veuillez réessayer.",
stageAdded: "{{stage}} ajouté",
couldNotAddCheck: "Impossible d’ajouter ce contrôle",
precheckFirst: "Faites d’abord le contrôle préalable",
notNow: "Plus tard",
runStage: "Exécuter {{stage}}",
couldNotStartJob: "Impossible de démarrer cette intervention",
movedToStatus: "Déplacée vers {{status}}",
couldNotMoveJob: "Impossible de déplacer cette intervention",
acceptedOn: "Accepté le",
rejectedOn: "Rejeté le",
sentToLine: "Envoyé à {{names}}.",
missingEmailForLine: "E-mail manquant pour {{names}}.",
noInvoiceOrReceiptAttached: "Aucun fichier de facture ou de reçu n'a été joint.",
completionSentTitle: "Achèvement envoyé",
completionEmailSent: "E-mail de fin envoyé.",
emailNotSentTitle: "E-mail non envoyé",
visitConfirmed: "Visite confirmée",
awaitingVisitConfirmation: "En attente de confirmation de visite",
recipientLine: "{{label}} : {{name}}",
recipientEmailSuffix: " ({{email}})",
requesterDeliveryLine: "Demandeur : {{status}}",
assigneeDeliveryLine: "Responsable : {{status}}",
helpMeWithJobDraft: "Aidez-moi avec cette intervention : {{title}}. Suggérez les prochaines étapes ou une ébauche de clôture.",
currentJobFallback: "Intervention actuelle",
captureNotSavedTitle: "Capture non enregistrée",
captureNotFoundBody: "Cette capture est introuvable. Veuillez la capturer à nouveau.",
captureMismatchBody: "Cette capture ne correspond pas à l'intervention actuelle.",
noPhotoWasCaptured: "Aucune photo n'a été prise.",
mustBeSignedInToSavePhotos: "Vous devez être connecté pour enregistrer des photos.",
capturedFromHome: "Capturé depuis l’accueil",
photoAddedToActivity: "Photo ajoutée à l'activité de l'intervention",
noDictationTextCaptured: "Aucun texte de dictée n'a été capturé.",
jobUpdateAdded: "Mise à jour publiée. Toutes les personnes de cette intervention la voient dans Activité.",
noNoteTextCaptured: "Aucun texte de note n'a été capturé.",
activityNoteAdded: "Note ajoutée. Toutes les personnes de cette intervention la voient dans Activité.",
readingCostNotePrefix: "Note de relevé/coût : {{value}}",
readingAddedToActivity: "Relevé ajouté à l'activité de l'intervention",
captureNotSupportedTitle: "Capture non prise en charge",
qrScanNotSavedBody: "Le scan QR est géré à partir du scanner et n’est pas enregistré dans l’activité de l’intervention.",
captureModeNotSupported: "Ce mode de capture n'est pas pris en charge pour les interventions.",
skillsUnavailableTitle: "Compétences indisponibles",
skillsUnavailableBody: "Impossible de charger les compétences pour le moment. Vous pouvez réessayer dans le sélecteur.",
followOnTitleSuffix: "{{title}} (suivi)",
workFallback: "Travail",
revisedWorkSubmitted: "Travail corrigé envoyé pour vérification. Le vérificateur a été prévenu.",
completionSubmittedAwaitingVerification: "Envoyé pour vérification. Le vérificateur le contrôle, puis le valide ou le renvoie.",
unableToCleanUp: "Impossible de nettoyer",
changeApproved: "Modification approuvée. L’intervention affiche la nouvelle date ou la nouvelle personne, et la personne qui l’a demandée a été prévenue.",
requestRejected: "Demande refusée. L’intervention reste telle quelle, et la personne qui l’a demandée a été prévenue.",
error: "Un problème est survenu",
couldNotRecordDecision: "Votre décision n’a pas été enregistrée. Vérifiez votre connexion et réessayez.",
savedOnDeviceWillSend: "Enregistré sur cet appareil — il sera envoyé lorsque vous serez de nouveau en ligne",
requestSent: "Demande envoyée. Rien ne change tant que le responsable ne l’a pas approuvée ; vous serez prévenu.",
couldNotSendRequest: "Votre demande n’a pas été envoyée. Vérifiez votre connexion et réessayez.",
outcomeLinePrefix: "Résultat : {{value}}",
meterReadingTitle: "Relevé du compteur",
enterMeterReadingBody: "Entrez le relevé du compteur sous forme de nombre ou laissez-le vide.",
readingLowerThanCurrentBody: "{{amount}} est inférieur au relevé actuel ({{current}}). Vérifiez la valeur, ou enregistrez une correction depuis la carte Maintenance de l’actif.",
readingLowerThanEarlierBody: "Ce relevé est inférieur à un relevé précédent. Vérifiez la valeur.",
readingAlreadyRecordedAfterBody: "Un relevé de {{current}} est déjà enregistré après celui-ci. Vérifiez la valeur.",
laterReadingAlreadyRecordedBody: "Un relevé ultérieur est déjà enregistré. Vérifiez la valeur.",
meterReadsInUnitBody: "Ce compteur relève en {{unit}}.",
completionSubmittedAwaitingOwnerVerification: "Envoyé pour vérification. La personne qui a créé l’intervention la contrôle, puis la valide ou la renvoie.",
failedToComplete: "L’intervention n’a pas été envoyée. Vos notes et photos sont conservées. Vérifiez votre connexion et réessayez.",
completeRequiredDetailsFirstTitle: "Remplissez d'abord les détails requis",
pleaseFixBeforeSubmitting: "Veuillez corriger ces points avant de soumettre l’achèvement :\n{{list}}",
goToCompletion: "Aller à l’achèvement",
cancel: "Annuler",
costBreakdownActionUnavailable: "Action de répartition des coûts indisponible. Veuillez actualiser l'application.",
jobAccepted: "Intervention acceptée. Touchez Démarrer quand vous commencez.",
failedToAccept: "L’intervention n’a pas été acceptée. Vérifiez votre connexion et réessayez.",
workApproved: "Travail validé. L’intervention est clôturée et l’historique de l’actif est à jour.",
requireSignOffForJobsThisSize: "Exiger une approbation pour les interventions de cette taille",
failedToApprove: "Le travail n’a pas été validé. Vérifiez votre connexion et réessayez.",
cannotCreateCertificateTitle: "Impossible de créer un certificat",
cannotCreateCertificateBody: "Cette intervention n'est pas liée à un bien.",
certificateCreatedTitle: "Certificat créé",
certificateCreatedBody: "Le certificat est lié à cette intervention et à cet actif.",
couldNotCreateCertificate: "Impossible de créer le certificat.",
deleteJobTitle: "Supprimer l'intervention",
actionCannotBeUndone: "Cette action ne peut pas être annulée.",
delete: "Supprimer",
jobDeleted: "Intervention supprimée",
failedToDelete: "L’intervention n’a pas été supprimée. Vérifiez votre connexion et réessayez.",
titleRequiredTitle: "Titre requis",
enterFollowOnTitleBody: "Saisissez un titre pour l’intervention de suivi.",
skillsRequiredTitle: "Compétences requises",
selectRequiredSkillBody: "Choisissez au moins une compétence pour cette intervention de suivi.",
followUpJobCreated: "Intervention de suivi créée. Elle se trouve dans Travail et est liée à cette intervention.",
followUpCreatedTitle: "Suivi créé",
followUpCreatedBody: "Intervention de suivi liée créée. Vous pouvez l'ouvrir à partir de l'achèvement ou continuer à compléter cette intervention.",
failedToCreateFollowOn: "L’intervention de suivi n’a pas été créée. Vérifiez votre connexion et réessayez.",
failedToApproveFollowOn: "Le suivi n’a pas été approuvé. Vérifiez votre connexion et réessayez.",
notApproved: "Non approuvé",
followUpNotApproved: "Suivi refusé. Il est annulé et votre motif figure dans son historique.",
failedToRejectFollowOn: "Le suivi n’a pas été refusé. Vérifiez votre connexion et réessayez.",
linkAContact: "Lier un contact",
requesterFallback: "Demandeur",
draftCloseout: "Rédiger la note avec l’IA",
draftInvoice: "Préparer la facture",
loadingJobDetails: "Chargement des détails de l'intervention...",
unableToLoadJob: "Impossible de charger l'intervention",
jobNotFound: "Intervention introuvable",
ownerFallback: "Propriétaire",
parentJobApproverFallback: "Approbateur de l’intervention parente",
assigneeFallback: "Assigné à",
everyoneDeclinedYouInviteMore: "Tous les invités ont refusé : vous en invitez davantage",
everyoneDeclined: "Tous les invités ont refusé",
contractorsSubmitQuotes: "Les prestataires soumettent des devis",
youRequestQuotes: "Vous demandez des devis",
ownerRequestsQuotes: "Le propriétaire demande des devis",
youPickAContractor: "Vous choisissez un sous-traitant",
ownerPicksAContractor: "Le propriétaire choisit un prestataire",
youAssignTheJob: "Vous attribuez l'intervention",
ownerAssignsTheJob: "Le propriétaire attribue l’intervention",
requesterConfirmsFixNamed: "{{name}} confirme le correctif",
assignedPrefix: "Assigné",
assignedToSuffix: " à {{name}}",
resolveBeforeSubmitting: "Résolvez ce problème avant de soumettre l'achèvement.",
tightenEvidenceCostsNotes: "Renforcez les preuves, les coûts ou les notes pour que l'approbation soit simple.",
captureFollowUpWorkHint: "Ajoutez le travail de suivi ou une intervention liée pour que rien ne soit oublié.",
noScheduledStartExplanation: "Cette intervention n'a pas de début planifié.",
setScheduleRecommendedAction: "Pas encore de date. Choisissez une date ou attribuez-la pour qu’elle ne prenne pas de retard.",
pastScheduledStartExplanation: "Cette intervention a dépassé sa date de début ou d'échéance prévue.",
updateScheduleRecommendedAction: "La date est passée. Replanifiez-la ou prévenez le demandeur.",
completionChecksClear: "Les contrôles d’achèvement ne signalent aucun problème pour cette fiche.",
keepUpdatesAlignedAction: "Gardez les mises à jour, les preuves, les coûts et les notes alignés au fur et à mesure de l'avancement des travaux.",
reviewCompletion: "Examiner l’achèvement",
openCompletion: "Ouvrir l’achèvement",
setSchedule: "Définir la planification",
updateSchedule: "Mettre à jour la planification",
inspectionLine: "Inspection : {{label}}",
openRelatedAsset: "Ouvrir l'actif associé",
jobInsight: "Aperçu de l’intervention",
insightWarnings_one: "{{count}} avertissement",
insightWarnings_many: "{{count}} d’avertissements",
insightWarnings_other: "{{count}} avertissements",
insightBlockers_one: "{{count}} blocage",
insightBlockers_many: "{{count}} de blocages",
insightBlockers_other: "{{count}} blocages",
insightSummaryLine: "{{warnings}}, {{blockers}}",
followUp: "Suivi",
suggested: "Suggéré",
thisJobsChecksAndStatus: "contrôles et statut de cette intervention",
contractorWorkspace: "Espace prestataire",
nextLine: "Suivant: {{value}}",
statusUnavailable: "Statut indisponible",
updatesNew: "Mises à jour · nouveau",
updates: "Mises à jour",
hideStatusHistory: "Masquer l'historique des statuts",
statusHistory: "Historique des statuts",
hideCompletionAndCosts: "Masquer l'achèvement et les coûts",
completionAndCosts: "Achèvement et coûts",
cancelJob: "Annuler l'intervention",
deleteJobAction: "Supprimer l'intervention",
moreJobOptions: "Plus d'options d'interventions",
approveCompletion: "Vérifier",
cantDoThis: "Refuser",
assignDirectly: "Attribuer directement",
jobAssistant: "Assistant d'interventions",
readOnly: "Lecture seule",
jobCreated: "Intervention créée",
suggestedNextStepLine: "Étape suivante suggérée : {{step}}.",
trackProgressHint: "Suivez l’avancement dans Activité, puis clôturez l’intervention une fois le travail terminé.",
dismissJobCreatedMessage: "Fermer le message « Intervention créée »",
gotIt: "Compris",
atAGlance: "En un coup d'œil",
status: "Statut",
next: "Suivant",
visit: "Visite",
cost: "Coût",
openAssetLabel: "Ouvrir l'actif {{name}}",
relatedRecords: "Dossiers associés",
couldNotSaveJobDetails: "Impossible d'enregistrer les détails de l'intervention.",
jobOptions: "Options d'intervention",
linkContactToJob: "Lier le contact à l'intervention",
relationship: "Relation",
couldNotAddExtractedLineItem: "Impossible d’ajouter l’article extrait",
jobFallback: "Intervention",
signInRequiredToUpload: "Connexion requise pour envoyer des fichiers.",
reopenJob: "Rouvrir l’intervention",
startJob: "Démarrer l'intervention",
acceptJob: "Accepter l'intervention",
workPath: "Qui s’en charge",
overdue: "En retard",
unscheduled: "Non planifié",
onSiteLine: "Sur place : {{location}}",
fromInspectionLine: "De l’inspection — {{label}}",
followOnOfLine: "Suivi de — {{title}}",
parentJobFallback: "intervention parente",
requestedByLine: "Demandé par — {{name}}",
roleAndNameLine: "{{role}} — {{name}}",
jobAssigned: "Intervention attribuée. La personne a été prévenue et doit l’accepter.",
contractorAssigned: "Prestataire attribué. Une invitation lui a été envoyée ; il doit accepter l’intervention.",
jobResumed: "Intervention reprise. Touchez Terminer quand le travail est fait.",
},
closeout: {
  extractLineItems: "Lire les articles de la facture",
  extractingLineItems: "Lecture de la facture…",
  generatingInvoice: "Création de la facture…",
  materialsSummary: "Ajoutez les pièces et fournitures. Nous en ferons le total pour la facture.",
followUpTitle: "Suivi",
suggestFollowUpWork: "Suggérer des travaux de suivi",
suggestNextSteps: "Suggérer les prochaines étapes",
apply: "Appliquer",
skillLine: "Compétence : {{value}}",
riskLine: "Risque : {{value}}",
costsAndInvoicesIncluded: ". Les coûts et les factures sont inclus ci-dessous.",
completedThisLine: "{{name}} a terminé ceci{{when}}. ",
requesterConfirmsFix: "Le demandeur confirme le correctif",
ownerFallback: "Propriétaire",
addDetailsBeforeSubmitting: "Ajoutez les détails de réalisation avant de soumettre.",
submitCompletion: "Soumettre l'achèvement",
completion: "Achèvement",
followUpJobsTitle: "Interventions de suivi",
followUpJobsSummary: "Ajoutez ou vérifiez les interventions de suivi une fois la note de fin prête.",
proposeFollowOnJob: "Proposer une intervention de suivi",
linkedHeldForApproval: "Lié à cette intervention et retenu pour approbation.",
proposeMoreWork: "Proposer d’autres travaux",
proposeMoreWorkHint: "Elle leur arrive comme une demande. Ils décident, et vous voyez la réponse ici.",
proposalSent: "Proposition envoyée",
proposalWaiting: "En attente de décision",
proposalApproved: "Approuvée",
proposalBecameJob: "Devenue une intervention",
proposalNotTaken: "Non retenue",
followUpJobsLinkedTitle: "Interventions de suivi liées",
createdNowPrefix: "Créé maintenant : ",
followUpPrefix: "Suivi : ",
pendingApprovalSuffix: " · En attente d'approbation",
followUpLinkedContinueBody: "L’intervention de suivi est liée. Vous pouvez continuer et terminer celle-ci.",
requiredBeforeSubmit: "Obligatoire avant la soumission",
beforeYouSubmit: "Avant de soumettre",
workCompleted: "Travail terminé",
workCompletedPlaceholder: "Quels travaux ont été réalisés ?",
rewriting: "Amélioration…",
rewrite: "Améliorer avec l’IA",
revert: "Revenir",
actualCost: "Coût réel",
leaveBlankToRecordAsZero: "Laissez vide pour enregistrer comme 0. Entrez le montant total de cette intervention s'il y a eu des frais.",
fromCostBreakdownReadOnly: "À partir de la répartition des coûts (lecture seule)",
verifiedLine: "Vérifié {{date}} | Coût réel {{amount}}",
costsLockedPendingVerification: "Les coûts sont verrouillés pendant que l'achèvement est en attente de vérification.",
quickFinishHint: "Clôture rapide : ajoutez les détails de réalisation et le coût réel, puis soumettez.",
costSummary: "Récapitulatif des coûts",
estimateLine: "Estimation : {{value}}",
actualTotalLine: "Total réel : {{value}}",
vsEstimateLine: "vs estimation : {{value}}",
actualCostHint: "Le coût réel doit inclure tous les frais liés à cette intervention.",
optionalBreakdownHint: "Facultatif : ajoutez une ventilation détaillée uniquement si nécessaire.",
detailedCostBreakdown: "Ventilation détaillée des coûts",
detailedCostBreakdownSummary: "Les matériaux, la main-d'œuvre, les taxes et autres frais sont facultatifs, sauf si cette intervention nécessite des coûts détaillés.",
optionalDetailedCostBreakdown: "Ventilation détaillée des coûts en option",
materialsBreakdownOptional: "Répartition des matériaux (facultatif)",
lineItemsOptional: "Articles (facultatif)",
failedToAddLineItem: "L’article n’a pas été ajouté. Vérifiez votre connexion et réessayez.",
add: "Ajouter",
itemName: "Nom de l'article",
removeItemTitle: "Supprimer l'élément",
removeItemBody: "Supprimer cet article ?",
cancel: "Annuler",
remove: "Supprimer",
error: "Un problème est survenu",
failedToUpdateLineItem: "L’article n’a pas été enregistré. Vérifiez votre connexion et réessayez.",
failedToRemoveLineItem: "L’article n’a pas été supprimé. Vérifiez votre connexion et réessayez.",
failedToUpdateQty: "La quantité n’a pas été enregistrée. Vérifiez votre connexion et réessayez.",
failedToUpdateUnitCost: "Le prix unitaire n’a pas été enregistré. Vérifiez votre connexion et réessayez.",
failedToUpdateTotalCost: "Le total n’a pas été enregistré. Vérifiez votre connexion et réessayez.",
quantityForItem: "Quantité pour {{name}}",
itemFallback: "article",
qty: "Qté",
unitCostForItem: "Coût unitaire pour {{name}}",
unit: "Unité",
totalForItem: "Total pour {{name}}",
total: "Total",
fromQtyTimesUnit: "À partir de la quantité × unité : {{amount}}",
manualTotalOverrideSuffix: " (total modifié par vous)",
useCalculatedTotal: "Utiliser le total calculé",
materialsSubtotal: "Sous-total matériaux : {{amount}}",
labourTaxOtherOptional: "Main-d'œuvre, taxes et autres frais (facultatif)",
costBreakdownOptional: "Ventilation des coûts (facultatif)",
failedToRemoveBreakdown: "Le détail n’a pas été supprimé. Vérifiez votre connexion et réessayez.",
failedToAddCostBreakdown: "Le détail n’a pas été ajouté. Vérifiez votre connexion et réessayez.",
removeBreakdown: "Supprimer la ventilation",
addBreakdown: "Ajouter une répartition",
labourExTax: "Main d'œuvre (hors taxes)",
taxEntry: "Saisie de taxe",
amount: "Montant",
percentOfLabour: "% de la main d'œuvre",
taxAmount: "Montant de la taxe",
taxRatePercentOfLabour: "Taux de taxe (% de la main-d’œuvre)",
taxRateLine: "Taux d'imposition : {{pct}} %",
otherCharges: "Autres frais",
otherChargeLabel: "Libellé des autres frais {{n}}",
label: "Libellé",
otherChargeAmount: "Montant des autres frais {{n}}",
totalBreakdownLine: "Total = Matériaux {{materials}} + Main d'œuvre {{labour}} + Taxe {{tax}} + Autres {{other}}",
totalLine: "Total : {{amount}}",
invoicesAndCloseoutEmail: "Factures et e-mail du rapport",
invoicesAndCloseoutEmailSummary: "Joignez des factures, ou envoyez le rapport une fois la note de fin prête.",
invoiceLabel: "Facture (PDF, image ou Word)",
generateInvoiceWithAi: "Générer une facture avec l'IA",
reviewInvoiceDraft: "Examiner le brouillon de la facture",
signInRequired: "Connexion requise",
emailCloseoutRecipients: "Envoyer le rapport au demandeur",
emailAlwaysIncludesSummary: "L’e-mail contient un résumé du travail. Les factures, reçus et photos sont joints s’il y en a.",
},
assetContextSection: {
asset: "Actif",
viewAssetKnowledgeBase: "Afficher la base de connaissances sur les actifs",
viewAssetKnowledge: "Afficher les connaissances sur les actifs",
noAssetLinked: "Aucun bien lié à cette intervention.",
overview: "Vue d’ensemble",
location: "Lieu",
fromLinkedAsset: "À partir de l'actif lié",
aboutThisJob: "À propos de cette intervention",
approverLine: "Approbateur : {{name}}",
approverFallback: "-",
sectionOfInterest: "Section d'intérêt",
viewSourceInspection: "Voir l’inspection d’origine",
fromInspection: "Depuis l'inspection",
video: "Vidéo",
photos: "Photos",
linkedRecords: "Enregistrements liés",
fromRequestLine: "Depuis la demande : {{id}}",
followsFromLine: "Suit : {{title}}",
parentJobFallback: "Intervention parente",
followOnLine: "Suivi : {{title}}",
sourceLine: "Source : {{label}}",
groupedScheduleLine_one: "{{count}} autre intervention active sur cet actif peut être planifiée en même temps.",
groupedScheduleLine_other: "{{count}} autres interventions actives sur cet actif peuvent être planifiées en même temps.",
groupedScheduleLine_many: "{{count}} d’autres interventions actives sur cet actif peuvent être planifiées en même temps.",
},
scheduleSection: {
rescheduleTo: "Replanifier à",
scheduleFor: "Planifier pour",
today: "Aujourd'hui",
tomorrow: "Demain",
nextWeek: "Semaine suivante",
custom: "Personnalisé",
selectDate: "Choisir une date",
time: "Heure",
selectTime: "Sélectionnez l'heure",
duration: "Durée",
plannedLine: "Prévu : {{value}}",
reasonOptional: "Motif (facultatif)",
reasonForReschedulePlaceholder: "Raison du report",
scheduleTogetherOptional: "Programmer ensemble (facultatif)",
groupSameAssetHint: "Regroupez les travaux sur un même actif pour éviter les visites répétées.",
unscheduledSuffix: " | Non planifié",
cancel: "Annuler",
reschedule: "Reprogrammer",
schedule: "Planifier",
},
deliveryModeSheet: {
cancel: "Annuler",
saving: "Enregistrement...",
save: "Enregistrer",
},
mediaViewer: {
couldNotLoadImage: "Impossible de charger l'image",
imageUnavailable: "L'image a peut-être été déplacée ou n'est pas disponible.",
},
handoffRecommendationPanel: {
  evidence: {
    beforeAfter: "À la fin : photos avant/après et une courte note.",
    replacementPhotos: "À la fin : photos avant/après et ce qui a été posé.",
    checklistPhotos: "À la fin : la liste de contrôle remplie et des photos de ce qui a échoué.",
  },
  reason: {
    originKept: {
      finding: "Elle reste liée au constat d’inspection.",
      inspection: "Elle reste liée à l’inspection.",
      request: "Elle reste liée à la demande.",
      asset: "Elle reste liée à l’actif.",
    },
    noOrigin: "Vérifiez les détails ci-dessus avant de la créer.",
    skillsUnconfirmed: "Aucune compétence ajoutée. Ajoutez-en si un métier précis est nécessaire.",
    skillsCarried_many: "{{count}} de compétences figurent déjà sur l’intervention.",
    skillsCarried_other: "{{count}} compétences figurent déjà sur l’intervention.",
    skillsCarried_one: "{{count}} compétence figure déjà sur l’intervention.",
    dueByPriority_many: "Priorité {{priority}} : visez une fin sous {{count}} de jours.",
    dueByPriority_other: "Priorité {{priority}} : visez une fin sous {{count}} jours.",
    dueByPriority_one: "Priorité {{priority}} : visez une fin sous {{count}} jour.",
    contractorNoInternal: "Personne n’est disponible dans votre équipe : choisissez un prestataire.",
    contractorFromSourceJob: "Elle revient au prestataire qui a réalisé l’intervention dont elle découle.",
    contractorCritical: "Personne n’est disponible dans votre équipe et c’est urgent : envoyez-la directement à un prestataire de confiance.",
    quotesHighValue: "Personne n’est disponible dans votre équipe et ce travail coûte cher : comparez d’abord quelques devis.",
    internalAvailableUnnamed: "Une personne de votre équipe peut s’en charger.",
    internalAvailable: "{{name}} de votre équipe peut s’en charger.",
  },
recommendedHandoff: "Suggestion",
titleLine: "{{mode}} · échéance dans {{days}} {{dayWord}}",
dayWord_one: "jour",
dayWord_other: "jours",
applied: "appliqué",
apply: "Utiliser cette suggestion",
whyRecommendedTitle: "Pourquoi ?",
priorityOverrideLine: "Priorité : {{priority}}. Modifiez-la sous Ajouter du contexte si elle est fausse.",
planningRangeLine: "Plage de planification {{min}}–{{max}} ; à confirmer avant de confier le travail.",
dayWord_many: "de jours",
},
statusInsight: {
theReviewer: "Le vérificateur",
reworkRequested: "Renvoyée",
workPath: "Qui s’en charge",
updating: "Mise à jour...",
internal: "Interne",
recipientView: "Vue Destinataire",
recipientViewBody: "Vous pouvez consulter cette intervention. La modification est limitée à ce que votre rôle permet.",
execution: "Réalisation",
executionBody: "Une fois le travail fait, touchez Terminer pour ajouter votre note, vos photos et vos coûts.",
nextStep: "Prochaine étape",
nextLine: "Suivant: {{actor}}",
followOnApproval: "Approbation du suivi",
followOnApprovalBody: "Approuvez cette intervention de suivi pour pouvoir l’attribuer et la dater.",
awaitingFollowOnApproval: "En attente d’approbation",
waitingForApproverBody: "Cette intervention de suivi attend une approbation. Elle ne peut pas être attribuée ni datée avant.",
waitingForParentApproverBody: "Cette intervention ne peut pas être attribuée ou planifiée tant que l'approbateur de l'intervention parente n'a pas décidé.",
overdue: "En retard",
unscheduled: "Non planifié",
},
activitySection: {
  assistantChange: "Modifié via l’assistant",
  assistantUndone: "Modification de l’assistant annulée",
  playVideo: "Lire la vidéo",
  openPhoto: "Ouvrir la photo",
statusNone: "Aucun",
systemActor: "Système",
userFallback: "Une personne de l’équipe",
taskTimeline: "Chronologie des tâches",
purposeHint: "Statut, messages, preuves et actions dans un seul espace de travail chronologique.",
noStatusEvents: "Aucun événement de statut pour l’instant.",
recentEvidence: "Preuves récentes",
noMessagesOrEvidence: "Aucun message ni preuve pour l'instant.",
openFullTimeline: "Ouvrir la chronologie complète >",
},
assignmentSection: {
contacts: "Contacts",
noContactsLinked: "Aucun contact lié.",
contactFallback: "Contact",
couldNotUnlinkTitle: "Impossible de dissocier le contact",
tryAgain: "Veuillez réessayer.",
linkContact: "Lier un contact",
assignmentAndSchedule: "Affectation et planification",
declinedSuffix: "{{name}} (refusé)",
awaitingAssignee: "En attente du responsable",
requesterLine: "Demandeur : {{name}}",
requesterEmailSuffix: " ({{email}})",
notLinkedYet: "Pas encore lié",
scheduledLine: "Planifié : {{value}}",
notScheduledYet: "Pas encore planifié",
closeoutRecipientsFallback: "Dès qu’une personne est attribuée, nous indiquerons qui reçoit le rapport final.",
completionEmailLine: "E-mail de finalisation : {{value}}",
rejected: "Refusée",
changeAssignee: "Changer de responsable",
change: "Modifier",
reassign: "Réassigner",
contractorType: "Prestataire",
internalTeamType: "Équipe interne",
reason: "Raison",
invitedAcceptedDeclinedLine: "Invité : {{total}} | Accepté : {{accepted}} | Refusé : {{declined}}",
pendingSuffix: " | En attente : {{pending}}",
quoteRequestLine: "Demande de devis : {{status}}",
quoteInvitedSubmittedDeclinedLine: "Invités : {{invited}} | Soumis : {{submitted}} | Refusés : {{declined}}",
quoteCountLine_one: "{{count}} devis : {{open}} ouvert | {{accepted}} accepté | {{rejected}} refusé",
quoteCountLine_many: "{{count}} de devis : {{open}} ouverts | {{accepted}} acceptés | {{rejected}} refusés",
quoteCountLine_other: "{{count}} devis : {{open}} ouverts | {{accepted}} acceptés | {{rejected}} refusés",
awardedToLine: "Attribué à : {{name}}",
execution: "Le travail",
started: "Commencée",
completed: "Terminé",
actualDuration: "Durée réelle",
elapsed: "Temps écoulé",
confirmed: "Confirmé",
confirmedBySuffix: " · {{name}}",
verified: "Vérifiée",
continueJob: "Continuer l'intervention",
continueJobHint: "Ajoutez les détails d'achèvement et le coût réel avant de soumettre.",
completion: "Achèvement",
},
statusGuidance: {
title: "Statut et conseils",
},
invoicePreview: {
title: "Examiner le brouillon de facture de l’IA",
hint: "Confirmez les détails, puis joignez le PDF généré à cette intervention.",
titleAndNumber: "{{title}} - {{number}}",
issueDate: "Date d’émission : {{date}}",
dueDateSuffix: " | Échéance : {{date}}",
from: "De",
billTo: "Facturer à",
lineItems: "Articles",
lineItemLine: "{{description}} x{{quantity}} - {{amount}}",
total: "Total : {{amount}}",
noDraftFound: "Aucun brouillon trouvé. Générez d’abord un brouillon de facture.",
back: "Retour",
attaching: "Ajout de la pièce jointe…",
attachPdf: "Joindre le PDF",
},
followOnModals: {
proposeTitle: "Proposer une intervention de suivi",
proposeHint: "Elle attend une approbation. Une fois approuvée, elle peut être attribuée et datée.",
titleLabel: "Titre",
descriptionLabel: "Description",
dictate: "Dicter",
improving: "Amélioration…",
improveWithAi: "Améliorer avec l'IA",
followOnTitleAria: "Titre de l’intervention de suivi",
titlePlaceholder: "Titre",
followOnDescriptionAria: "Description de l’intervention de suivi",
descriptionPlaceholder: "Quels travaux supplémentaires sont nécessaires ?",
insertingDictatedText: "Insertion d'un texte dicté...",
finishingDictation: "Fin de la dictée...",
heardTranscript: "Entendu : {{transcript}}",
listening: "Écoute...",
photosAndVideos: "Photos et vidéos",
requiredSkills: "Compétences requises",
cancel: "Annuler",
submitting: "Envoi…",
submitForApproval: "Soumettre pour approbation",
rejectTitle: "Refuser l’intervention de suivi",
rejectHint: "L’intervention de suivi est annulée. Ajoutez une courte raison pour l’équipe.",
rejectionReasonAria: "Motif du refus",
reasonPlaceholder: "Raison",
rejectFollowOn: "Refuser",
},
dockBar: {
  waitingForRequester: "En attente du demandeur",
approve: "Approuver",
reject: "Refuser",
accept: "Accepter",
acceptAndStart: "Accepter et démarrer",
acceptAndSchedule: "Accepter et planifier",
cantDoThis: "Refuser",
reassign: "Réassigner",
rework: "Renvoyer",
requestEvidence: "Demander des photos",
verify: "Valider",
resubmit: "Soumettre à nouveau",
getQuotes: "Obtenir des devis",
inviteMore: "Inviter d’autres personnes",
compare: "Comparer",
sendQuotes: "Envoyer des devis",
assign: "Assigner",
startNow: "Démarrer maintenant",
schedule: "Planifier",
start: "Démarrer",
reschedule: "Reprogrammer",
complete: "Terminer",
pause: "Mettre en pause",
resume: "Reprendre",
report: "Rapport",
},
certificateSuggestion: {
needsConnection: "Les suggestions de certificat nécessitent une connexion.",
evidenceDoesNotSupport: "Les preuves d’achèvement ne justifient pas encore clairement un certificat.",
createPendingTitle: "Créer un certificat en attente",
createPendingBody: "Créer un certificat à partir de cette intervention ? Il restera en attente de validation jusqu'à son examen.",
cancel: "Annuler",
continue: "Continuer",
jobFallback: "Intervention",
certificateSuffix: "Certificat {{title}}",
titleLine: "Titre : {{value}}",
typeLine: "Type : {{value}}",
expiryLine: "Expiration : {{value}}",
cardTitle: "Suggérer un certificat à partir d'une preuve d'achèvement",
optionalAiHint: "Assistance IA en option une fois l’intervention terminée.",
reviewDraftLabel: "Réviser le projet de certificat",
suggestWithAi: "Suggérer un certificat avec IA",
addManually: "Ajouter un certificat manuellement",
},
verified: {
  submitCheckNote: "À l’envoi, l’IA compare les photos « après » à ce que demande l’intervention.",
  documentHintSheet: "Fermez cette fenêtre, puis touchez Joindre un document sur l’intervention.",
  noteHintSheet: "Rédigez-la dans la note de fin sur cet écran.",
  noteHint: "Rédigez-la dans la note de fin quand vous touchez Terminer.",
  attachDocument: "Joindre un document",
  recordReading: "Saisir le relevé",
  heading: "Ce dont cette intervention a besoin",
  progress: "{{done}} sur {{total}} faits",
  takePhoto: "Prendre une photo",
  stage: {
    pre: "Avant de commencer",
    post: "À la fin",
    standalone: "Liste de contrôle",
  },
  beforePhoto: "Photo avant",
  afterPhoto: "Photo après",
  beforePhotos: "Photos avant",
  addBeforePhoto: "Ajouter une photo avant",
  required: "Obligatoire",
  recommended: "Recommandé",
  rowState: {
    notSupplied: "Non fourni",
    done: "Fait",
    uploading: "Envoi en cours…",
    added: "Ajoutée",
    missing: "Manquant",
    attention: "À regarder",
    unchecked: "Pas encore vérifié",
  },
  status: {
    consistent: "Les photos correspondent au travail décrit",
    review_required: "Les photos méritent un regard",
    missing_evidence: "Photos manquantes",
    inconsistent: "Les photos ne correspondent pas au travail décrit",
    unable_to_determine: "Impossible à déterminer sur les photos",
  },
  checkNote: {
    meter_not_recorded: "Relevé de compteur non enregistré",
    document_not_attached: "Document non joint",
    check_not_completed: "Contrôle non terminé",
    note_missing: "Note manquante",
    not_visible: "Non visible sur les photos",
    partly_visible: "Partiellement visible seulement",
    low_confidence: "Pas assez net pour conclure",
    contradicted: "Les photos montrent le contraire",
    cloud_unavailable: "Évaluation automatique indisponible",
    not_visually_verifiable: "Impossible à déterminer à partir de photos",
  },
  warning: {
    cloud_unavailable: "Évaluation automatique indisponible. La personne chargée de la vérification peut toujours examiner les preuves.",
    subject_mismatch: "Les photos avant et après ne montrent peut-être pas le même composant.",
    low_quality_after: "Les photos après sont floues, sombres ou masquées. Des photos plus nettes sont recommandées.",
    new_defect_after: "Un défaut non couvert par les travaux est visible sur les photos après.",
    detector_disagreement: "Les photos vont dans les deux sens. Une personne tranche.",
    pending_uploads: "Certaines photos sont encore en cours d’envoi et n’ont pas été évaluées.",
    reviewer_required: "Ces travaux doivent être approuvés par une personne.",
    post_inspection_required: "Inspection finale en attente.",
  },
  moreEvidenceRequested: "Photos supplémentaires demandées",
  stale: "Les preuves ont changé. L’évaluation doit être mise à jour.",
  checkEvidence: "Vérifier les photos",
  checkAgain: "Vérifier à nouveau",
  checking: "Vérification des preuves…",
  checkEvidenceA11y: "Vérifier les preuves de fin de travaux",
  resubmit: "Soumettre à nouveau",
  resubmitA11y: "Soumettre à nouveau la fin de travaux avec les preuves ajoutées",
  resubmitted: "Renvoyé pour vérification. Le vérificateur a été prévenu.",
  requestEvidence: "Demander des photos",
  requestEvidenceA11y: "Demander plus de photos",
  cloudUnavailable: "La vérification automatique des photos n’est pas disponible pour le moment. Regardez les photos et décidez.",
  reportEyebrow: "Évaluation des preuves (automatique)",
  editRequirements: "Modifier les exigences",
  editSummary: "Listes de contrôle, photos et résultats de cette intervention",
  saved: "Exigences enregistrées. Toute évaluation antérieure doit être mise à jour.",
  suggestFailed: "Aucune suggestion reçue. Ajoutez les résultats à la main.",
  kind: {
    visual: "Visible sur les photos",
    meter: "Relevé de compteur",
    document: "Document",
    check: "Liste de contrôle",
    note: "Note",
  },
  remove: "Retirer",
  removeA11y: "Retirer « {{text}} »",
  addOutcomePlaceholder: "Ajouter un résultat attendu, p. ex. Protection de remplacement en place",
  addOutcome: "Ajouter un résultat",
  suggestWithAi: "Suggérer avec l’IA",
  saveRequirements: "Enregistrer les exigences",
  reportPhotosAssessed: "Photos évaluées",
  reportRecordsOnly: "Enregistrements seulement",
},
closeoutPane: {
askForPhotos: "Demander des photos",
viewCompletionReport: "Afficher le rapport d'achèvement",
emailCloseoutRecipients: "Envoyer le rapport au demandeur",
sending: "Envoi…",
waitingOnRequester: "En attente du demandeur",
verifyCompletedWork: "Valider le travail terminé",
requesterGatePendingBody: "Le demandeur vérifie d’abord le travail. Une fois qu’il confirme, touchez Vérifier pour clôturer. Vous pouvez toujours Renvoyer.",
requesterAcceptedBody: "Le demandeur a confirmé qu’il est satisfait. Touchez Valider pour clôturer.",
reviewAndApproveBody: "Vérifiez la note, les photos et les coûts, puis touchez Valider pour clôturer, ou Renvoyer si quelque chose doit être corrigé.",
requestRework: "Renvoyer",
rework: "Renvoyer",
verify: "Valider",
certificateRenewalTitle: "Renouvellement du certificat",
certificateRenewalBody: "Créez le certificat de remplacement à partir de cette intervention terminée et liez-le au certificat précédent.",
createCertificateFromJob: "Créer un certificat à partir d'une intervention",
createCertificate: "Créer un certificat",
},
assignSheet: {
  chooseContractorsToQuote: "Choisir les prestataires à consulter",
  chooseContractor: "Choisir un prestataire",
  assignToContractor: "Attribuer à un prestataire",
  inviteTeammate: "Inviter un coéquipier",
close: "Fermer",
youSuffix: "{{name}} (Vous)",
searchTeamMembersPlaceholder: "Rechercher les membres de l’équipe…",
noTeamMemberMatch: "Aucun membre de l'équipe ne correspond.",
createTeamHint: "Ajoutez un coéquipier pour lui attribuer du travail, ou attribuez-le-vous.",
teammate: "Attribuer à un coéquipier",
assignToMyself: "M'attribuer",
},
},
create: {
  skillsTryAgain: "Réessayer",
  skillsEmpty: "Aucune compétence à choisir pour le moment. Touchez Réessayer, ou continuez sans.",
  createAndAssignJob: "Créer et attribuer l’intervention",
  fromRequestPageTitle: "Confirmer l’intervention depuis la demande",
  checkAttachFailedTitle: "Intervention créée, liste de contrôle manquante",
  assetLoadFailed: "L’actif lié n’a pas pu être chargé. Vérifiez votre connexion et réessayez.",
  assetUnavailable: "Cet actif est indisponible ou vous n’y avez plus accès.",
  assetStatus: {
    retired: "Retiré définitivement",
    archived: "Archivé",
    active: "Actif",
  },
  visibilityHint: "Privé : vous et les personnes sur cette intervention uniquement. Équipe : toute votre équipe.",
  priorityOption: {
    critical: "Critique",
    high: "Haute",
    medium: "Moyenne",
    low: "Basse",
  },
  categoryOption: {
    other: "Autre",
    replacement: "Remplacement",
    inspection: "Inspection",
    maintenance: "Maintenance",
    repair: "Réparation",
  },
unsavedGuard: {
message: "Cette intervention n'a pas encore été créée. Partir et la perdre ?",
discard: "Quitter",
keep: "Continuer à modifier",
},
assetRetiredTitle: "Actif retiré définitivement",
assetArchivedTitle: "Actif archivé",
assetRetiredBody: "Cet actif a été retiré définitivement (hors service). Son historique reste consultable, mais il ne peut plus recevoir de nouvelles interventions.",
assetArchivedBody: "Cet actif est archivé. Vous pouvez toujours afficher/modifier l'actif, mais vous ne pouvez pas créer de nouvelles interventions pour celui-ci.",
linkFollowUpFallback: "La demande n’a pas été mise à jour.",
checkAttachFailed: "L’intervention est créée, mais la liste « {{name}} » n’a pas été ajoutée. Ouvrez l’intervention et touchez Ajouter un contrôle.",
createFailed: "L’intervention n’a pas été créée. Vos informations sont conservées. Vérifiez votre connexion et réessayez.",
error: "Un problème est survenu",
followUpLinked: "Suivi lié à l'intervention",
calendarInviteTitle: "Intervention : {{name}}",
genericAssetFallback: "Actif",
recovery: {
followUpTitle: "Intervention créée, demande non mise à jour",
followUpBody: "{{message}} L’intervention a été créée. Touchez Relancer le lien pour qu’elle apparaisse dans la demande.",
retryLink: "Relancer le lien",
openJob: "Ouvrir l'intervention",
assetErrorTitle: "Impossible de charger l'élément lié",
assetLoadingTitle: "Chargement de l'actif lié…",
assetErrorBody: "{{error}} Le descriptif de travail que vous avez saisi est conservé.",
retryAsset: "Réessayer l'élément",
requestErrorTitle: "Impossible de charger la requête",
requestErrorBody: "Cette intervention doit être préremplie à partir de la demande. Réessayez de charger ses détails : tout ce que vous avez déjà saisi est conservé.",
retry: "Réessayer",
},
createdFromRequest: "Créé à partir d'une demande",
createdFromAsset: "Créé à partir de l'actif",
notSet: "Non défini",
noPriority: "Aucune priorité",
openAsset: "Ouvrir l’actif",
followOnDetailsTitle: "Détails de l’intervention de suivi",
workBriefTitle: "Descriptif du travail",
followOnHint: "Liée à l’intervention d’origine{{parent}}. Elle reprend le même actif et la même façon de faire. Attribuez-la et choisissez une date une fois approuvée.",
workPathTitle: "Qui s’en charge ?",
linkAssetLabel: "Lien vers l'actif (facultatif)",
selectAssetPlaceholder: "Sélectionnez un actif",
titleLabel: "Titre",
titlePlaceholder: "par ex. Réparer le robinet qui fuit",
titleError: "Entrez un titre d'intervention pour continuer.",
descriptionLabel: "Décrire le problème (facultatif)",
descriptionPlaceholder: "Que faut-il faire ? Ajoutez des détails pour que le responsable ait du contexte.",
dictateStop: "Arrêter",
dictateStart: "Dicter",
cleaningUp: "Amélioration…",
aiCleanUp: "Améliorer avec l’IA",
photosLabel: "Photos (facultatif, 3 maximum)",
completionEvidence: {
  title: "Preuves de fin de travaux",
  summary: "Les preuves du travail terminé exigées pour cette intervention",
  beforePhoto: "Photo avant",
  afterPhoto: "Photo après",
  level: {
    none: "Non requise",
    recommended: "Recommandée",
    required: "Obligatoire",
  },
  reviewerRequired: "Approbation par une personne",
  postInspection: "Inspection après travaux",
  requiredHint: "Les preuves obligatoires bloquent la fin des travaux tant qu’elles manquent.",
  recommendedHint: "Les preuves recommandées avertissent sans jamais bloquer.",
},
categoryLabel: "Catégorie *",
categoryError: "Choisissez une catégorie pour continuer.",
skillsOptionalLabel: "Compétences (facultatif)",
requiredSkillsLabel: "Compétences requises",
requiredSkillsError: "Choisissez au moins une compétence pour l’intervention de suivi. Celles de l’intervention d’origine sont reprises si elle en a.",
requiredSkillsHint: "Choisissez au moins une compétence. Celles de l’intervention d’origine sont reprises si elle en a.",
addContext: "Ajouter un contexte (facultatif)",
priorityLabel: "Priorité",
locationLabel: "Lieu (facultatif)",
locationPlaceholder: "Rechercher une adresse…",
assignScheduleTitle: "Attribuer et planifier",
assignScheduleSummary: "Date d'échéance, planification et responsable",
dueDateLabel: "Date d’échéance (facultatif)",
selectDatePlaceholder: "Choisir une date",
dueDateHint: "Date d’achèvement cible. Laissez la planification vide si ce travail ne nécessite pas encore de créneau spécifique.",
scheduledDateLabel: "Date programmée (facultatif)",
planDatePlaceholder: "Choisir une date",
startTimeLabel: "Heure de début",
selectTimePlaceholder: "Sélectionnez l'heure",
estimatedDurationLabel: "Durée estimée",
suggestedDuration: "suggéré : {{duration}} ({{reason}})",
useSuggestedDuration: "Utiliser la durée suggérée",
applied: "appliqué",
useSuggestion: "Utiliser la suggestion",
plannedPreview: "Prévu : {{preview}}",
clearSchedule: "Effacer la planification",
inviteLabel: "Inviter (facultatif)",
setDateHint: "Fixez une date pour planifier le début des travaux.",
quotesContractorHint: "Vous choisissez les entrepreneurs à inviter à proposer un devis après la création de l'intervention.",
directContractorHint: "Vous choisissez l'entrepreneur après la création de l'intervention.",
assignTeamMemberLabel: "Attribuer à un membre de l'équipe (facultatif)",
searchTeamMembersPlaceholder: "Rechercher les membres de l’équipe…",
noTeamMemberMatch: "Aucun membre de l'équipe ne correspond.",
assignSuggestedMember: "Attribuer le membre suggéré, {{name}}",
suggestedAssignee: "suggéré : {{name}}",
assignAnytimeHint: "Attribuer maintenant ou attribuer après la création de l'intervention.",
advancedSettingsTitle: "Plus de détails",
advancedSettingsSummary: "Catégorie, durée, contrôles, invitation d’agenda, coût et visibilité",
estimatedCostLabel: "Coût estimé (facultatif)",
estimatedCostAmount: "Montant du coût estimé",
visibilityLabel: "Visibilité",
submitting: "Envoi…",
submitForApproval: "Soumettre pour approbation",
creating: "Création en cours…",
createJob: "Créer une intervention",
followOnPageTitle: "Proposer une intervention de suivi",
createPageTitle: "Créer une intervention",
followOnSubtitle: "Elle attend une approbation avant de pouvoir être attribuée.",
requestSubtitle: "Vérifiez les détails, choisissez qui s’en charge et pour quand, puis touchez Créer et attribuer l’intervention.",
manualSubtitle: "Décrivez le travail et choisissez une catégorie. Vous pourrez l’attribuer et le planifier ensuite.",
linkAssetSheetTitle: "Lien vers l'actif",
noneOption: "Aucun",
openLinkedAsset: "Ouvrir l'actif lié",
cleanedDescriptionTitle: "Description améliorée",
cleaningUpDescription: "Amélioration de la description…",
reviewSuggestedWording: "Vérifiez la formulation suggérée avant de l'appliquer.",
unableToCleanUpTitle: "Impossible d’améliorer la description",
tryAgain: "Veuillez réessayer.",
},
recurring: {
  addStepNote: "Ce plan devient l’étape {{n}} de {{name}}.",
  saved: {
    dateInspection: "Plan enregistré. La première inspection apparaît dans Travail le {{when}}.",
    dateJob: "Plan enregistré. La première intervention apparaît dans Travail le {{when}}.",
    meterInspection: "Plan enregistré. La première inspection apparaît dans Travail quand le compteur atteint {{amount}}.",
    meterJob: "Plan enregistré. La première intervention apparaît dans Travail quand le compteur atteint {{amount}}.",
    eitherInspection: "Plan enregistré. La première inspection apparaît dans Travail à {{amount}} ou le {{when}}, au premier des deux termes.",
    eitherJob: "Plan enregistré. La première intervention apparaît dans Travail à {{amount}} ou le {{when}}, au premier des deux termes.",
    conditionInspection: "Plan enregistré. Une inspection apparaît dans Travail quand le score d'état descend à {{score}} ou moins.",
    conditionJob: "Plan enregistré. Une intervention apparaît dans Travail quand le score d'état descend à {{score}} ou moins.",
    manual: "Plan enregistré. Rien n'apparaît dans Travail tant que personne n'appuie sur Démarrer maintenant dans l'onglet Maintenance de l'actif.",
    needsReading: "Plan enregistré. Enregistrez un relevé de compteur sur l'actif pour qu'il commence à compter.",
    nowInspection: "Plan enregistré. La première inspection est déjà dans Travail.",
    nowJob: "Plan enregistré. La première intervention est déjà dans Travail.",
    generic: "Plan enregistré. Vous le trouverez dans l'onglet Maintenance de l'actif.",
  },
  skipPolicy: {
    hint: {
      not_allowed: "Une visite peut être déplacée ou confiée à quelqu’un d’autre, mais jamais ignorée.",
      no_approval: "La personne qui fait le travail peut ignorer une visite immédiatement. Les approbateurs de l'actif sont prévenus.",
      team_admin: "Seul un propriétaire ou un administrateur d'équipe peut accepter d'ignorer une visite.",
      requires_approval: "Chacun peut demander d'ignorer ou de déplacer une visite ; un approbateur de l'actif décide.",
      default: "Non choisi : un responsable décide — un administrateur d'équipe si l'actif a une obligation de conformité.",
    },
    not_allowed: "Ne jamais ignorer",
    no_approval: "Ignorer sans demander",
    team_admin: "Un administrateur d’équipe décide",
    requires_approval: "Un responsable décide",
    label: "Si une visite ne peut pas être faite",
  },
  meterNowHint: "Enregistré comme premier relevé, pour que le plan sache d’où compter.",
  meterNow: "Relevé actuel du compteur",
  createTemplate: "Créer une check-list",
  noTemplates: "Aucun check-list pour l'instant. Créez-en un : il sera choisi ici pour vous.",
  addDocument: "Ajouter un document",
  pickAssetFirst: "Choisissez d'abord l'actif, puis l'un de ses documents.",
  cannotManage: "Vous ne pouvez pas ajouter de plan à {{asset}}. Demandez à son propriétaire ou à un administrateur d’équipe.",
  assetPickerSubtitle: "Un plan appartient à un seul actif. Le travail qu’il crée apparaît dans Travail pour cet actif.",
maintenanceSave: "Créer le plan",
maintenanceSuccessTitle: "Plan créé",
maintenanceSuccessBody: "Le travail est créé à l’échéance du plan. Gérez-le depuis l’onglet Maintenance de l’actif.",
maintenanceHeading: "Plan de maintenance",
maintenanceSub: "Un travail qui revient : un entretien, un test ou une inspection. Choisissez l'actif, indiquez ce qui est fait et à quelle échéance. L’intervention apparaît dans Travail à chaque échéance.",
modeWhenDue: "À l’échéance",
repeatEvery: "Répéter par date",
everyCount: "Tous les",
unit: {
hours: "heures",
days: "jours",
weeks: "semaines",
months: "mois",
years: "ans",
},
edit: {
  loadFailed: "Ce plan n'a pas pu être ouvert. Vérifiez votre connexion et réessayez.",
heading: "Modifier le plan",
sub: "Les changements s'appliquent à partir de la prochaine échéance du plan. Le travail déjà créé n'est pas modifié.",
save: "Enregistrer les modifications",
savedTitle: "Plan mis à jour",
savedBody: "Le changement s'applique à partir de la prochaine échéance du plan. Le travail déjà créé n'est pas modifié.",
notFound: "Ce plan n'a pas pu être trouvé. Il a peut-être été terminé.",
conflict: "Quelqu’un d’autre a enregistré ce plan après que vous l’avez ouvert. Vos modifications n’ont pas été appliquées — revenez en arrière, rouvrez-le et refaites-les.",
},
meterEvery: "Répéter par compteur",
meterInterval: "Tous les",
meterKind: {
mileage: "Kilométrage",
operating_hours: "Heures",
cycles: "Cycles",
},
meterCurrent: "Le compteur affiche {{amount}} actuellement.",
meterNoReading: "Aucun relevé pour le moment — enregistrez-en un sur l'actif pour que le plan ait une base de calcul.",
whicheverFirst: "Selon la première échéance atteinte",
lastDone: "Dernière réalisation (facultatif)",
lastDoneDate: "Date",
lastDoneTime: "Heure",
lastDoneMeter: "Compteur au dernier entretien",
lastDoneHint: "Laissez vide pour compter à partir d'aujourd'hui et du relevé actuel.",
moreOptions: "Plus d'options",
meterAlso: "Répéter aussi selon le relevé du compteur",
meterRemove: "Retirer la répétition au compteur",
unitPickerTitle: "Répéter tous les",
lastDoneHintNow: "Laissez vide si jamais fait.",
whoDoesIt: "Qui s’en charge (facultatif)",
nobodyYet: "Décider à chaque fois",
whoDoesItHint: "Chaque passage est confié à {{name}}, qui est prévenu à son arrivée.",
nobodyYetHint: "Chaque passage arrive jusqu’à deux semaines avant l’échéance et vous êtes invité à l’affecter, avec un rappel 3 jours avant.",
assetPlaceholder: "Choisir un actif",
firstRunDatePlaceholder: "Date",
firstRunTimePlaceholder: "Heure",
ok: "OK",
unsavedGuard: {
editMessage: "Vos modifications apportées à ce plan ne sont pas enregistrées. Partir et les perdre ?",
createMessage: "Ce plan n'est pas encore enregistré. Quitter et le perdre ?",
discard: "Quitter",
keep: "Continuer à modifier",
},
doItAs: "Réaliser sous forme de",
asJob: "Intervention",
asInspection: "Inspection",
pickTemplate: "Choisissez une check-list",
serviceReading: "Relevé du compteur à l'entretien",
useReading: "Utiliser {{amount}} comme relevé d'entretien",
heading: "Plan de maintenance",
sub: "Crée la prochaine intervention pour vous selon une planification : après la fin de la précédente, ou à la date du calendrier.",
asset: "Actif",
title: "Ce qui est fait",
titlePh: "ex. Entretien annuel",
description: "Détails (facultatif)",
descriptionPh: "Ce qu’il faut faire à chaque fois",
category: "Catégorie",
firstRun: "Premier passage (date et heure)",
recurrence: "Répétition",
advanceMode: "Comment la prochaine intervention doit-elle être créée ?",
modeCompletion: "Après la fin de l'intervention précédente",
modeCalendar: "À la date d'échéance du calendrier",
modeHint: {
when_due: "La prochaine intervention apparaît quand la date ou le compteur l'indique — selon la première échéance atteinte. Rien n'est créé avant cela.",
on_completion: "La prochaine intervention apparaît après que vous ayez terminé ou annulé l'intervention en cours de cette série.",
on_calendar: "Une nouvelle intervention est créée à chaque échéance, même si l'intervention précédente est encore ouverte (sauf si vous activez l'option ci-dessous).",
},
skipIfPriorOpen: "Ignorer la suivante si la précédente est encore ouverte",
seriesLimits: "Arrêter la répétition (facultatif)",
seriesLimitsHint: "Laissez les deux vides pour continuer la répétition.",
endDate: "Se termine le",
endTime: "Heure de fin",
checksHint: "Ajoutée à chaque intervention créée par ce plan.",
maxJobs: "Arrêter après ce nombre d’interventions",
maxPh: "Aucune limite",
save: "Créer la série",
saving: "Création…",
successTitle: "Série créée",
successBody: "La première intervention est dans Travail ; les suivantes suivront votre planification.",
errorTitle: "Plan non enregistré",
footer: "Actif : {{asset}}",
errors: {
  meterNowFailed: "Ce relevé n'a pas pu être enregistré. Vérifiez le nombre et réessayez.",
  meterNow: "Saisissez le relevé actuel du compteur.",
every: "Indiquez la fréquence, en nombre entier.",
meter: "Indiquez la fréquence, en {{unit}}.",
noLeg: "Ajoutez une répétition par date, par compteur, ou les deux.",
template: "Choisissez une check-list pour l'inspection.",
lastDone: "Choisissez une date de dernière réalisation valide, ou laissez vide.",
lastDoneMeter: "Indiquez le relevé au dernier entretien, ou laissez vide.",
readingLower: "Le relevé d'entretien est inférieur au relevé actuel {{amount}}.",
asset: "Choisissez l'actif concerné par ce plan.",
title: "Indiquez ce qui est fait.",
datetime: "Choisissez une date et une heure de premier passage valides.",
endInvalid: "Choisissez une date d'arrêt valide.",
endBeforeStart: "La date d'arrêt doit être identique ou postérieure à la première.",
max: "Indiquez le nombre d’interventions, ou laissez vide.",
generic: "Votre plan n'a pas été enregistré. Vérifiez votre connexion et réessayez.",
},
serviceReadingHint: "La prochaine maintenance est comptée à partir de ce relevé.",
dueBy: "Quelle est l’échéance ?",
trigger: {
  schedule: "Tous les…",
  fixed_date: "À des dates fixes",
  document_renewal: "Quand un document expire",
  condition: "Quand l'état baisse",
  manual: "Pas de calendrier, je le lance",
},
triggerHint: {
  fixed_date: "Le travail est créé à chaque date.",
  document_renewal: "Le travail est créé à l’expiration du document. L’enregistrement de son renouvellement fait passer le plan à la nouvelle date d’expiration.",
  condition: "Le travail est créé lorsque le score d’état de l’actif descend à cette valeur ou en dessous.",
  manual: "Rien n’est créé automatiquement. Lancez-le depuis l’onglet Maintenance de l’actif quand c’est nécessaire.",
},
dates: "Dates prévues",
addDate: "Ajouter une date",
removeDate: "Retirer cette date",
pickDocument: "Choisir un document",
documentExpires: "{{title}} · expire le {{when}}",
noDocuments: "Cet actif n'a encore aucun document avec une date d'expiration. Ajoutez-en un, puis revenez le choisir.",
conditionScore: "Score d’état (0–100)",
errorDates: "Ajoutez au moins une date.",
errorDocument: "Choisissez le document dont l’expiration rend le plan dû.",
errorCondition: "Saisissez un score d’état de 0 à 100.",
},
handoff: {
  couldNotLoadTeam: "L’équipe n’a pas pu être chargée. Vérifiez votre connexion et touchez Réessayer.",
  assignToMyself: "Me l’attribuer",
  inviteTeammate: "Inviter un coéquipier",
  createdSubtitleAssigned: "Elle est maintenant dans Travail, attribuée à {{name}}. Choisissez une date une fois qu’elle l’aura acceptée.",
  createdSubtitle: "Elle est maintenant dans Travail. Choisissez qui s’en charge et quand. La personne sera prévenue quand vous la lui attribuerez.",
  createdTitle: "Intervention créée",
  assignTitle_many: "Attribuer les interventions",
  assignTitle_other: "Attribuer les interventions",
  assignTitle_one: "Attribuer l’intervention",
pageTitle: "Attribuer l’intervention",
releaseFollowUpTitle: "Approuver l’intervention de suivi",
releaseSubtitle: "Approuvez-la, choisissez qui s’en charge et fixez une date.",
batchSubtitle: "Choisissez qui s’occupe de chaque intervention et quand. Les personnes seront prévenues quand vous les leur attribuerez.",
emptyTitle: "Aucune intervention à attribuer",
emptyBody: "Il n’y a aucune intervention à attribuer ici. Revenez à Travail pour en trouver.",
backToWork: "Retour à Travail",
releaseHandoffTitle: "Approuver et attribuer",
smoothHandoffTitle: "Attribuer chaque intervention",
releaseIntroText: "Chaque carte indique qui a demandé le travail, qui s’en charge, quand, et qui reçoit le rapport final. L’approbation permet de l’attribuer et de la dater.",
batchIntroText: "Chaque carte indique qui a demandé le travail, qui s’en charge, quand, et qui reçoit le rapport final. Après une attribution, la suivante s’affiche.",
applyToAllJobs: "Appliquer aux {{count}} interventions",
scheduleAllJobsTogether: "Planifier toutes les interventions ensemble",
scheduleTogether: "Programmer ensemble",
setWorkPathToAllJobs: "Pour toutes les interventions : {{mode}}",
allInternal: "Tout à notre équipe",
allToContractor: "Tout à un prestataire",
allToQuotes: "Devis pour toutes",
pendingRelease: "À approuver",
requester: "Demandeur",
noRequesterLinked: "Aucun demandeur lié pour l'instant",
requesterNoneLinked: "Aucun demandeur lié : seule votre équipe reçoit le rapport.",
assigneeLine: "Responsable : {{name}}",
setOnRelease: "Choisi à l’approbation",
verbAssignToTeam: "attribuer à l'équipe",
verbAssignToContractor: "attribuer à l'entrepreneur",
verbRequestQuotes: "demander des devis",
approveAndVerb: "Approuver et {{verb}}",
changeAssignee: "Changer de responsable",
workPathLabel: "Qui s’en charge ?",
assigneeLabel: "Assigné à",
plannedDateLabel: "Date prévue",
completionRecipientsLabel: "Qui reçoit le rapport final",
requiredSkillsLabel: "Compétences requises",
notScheduledYet: "Pas encore planifié",
awaitingAcceptance: "{{name}} · en attente d'acceptation",
notAssignedYet: "Pas encore attribué",
assignToName: "Attribuer à {{name}}",
someoneElse: "Quelqu’un d’autre",
sourceContractorHint: "{{name}} a réalisé l’intervention dont celle-ci découle.",
awaitingNote: "Vous pourrez choisir une date une fois acceptée",
changeDate: "Changer la date",
planDate: "Choisir une date",
viewJobLabel: "Afficher l'intervention {{title}}",
viewJob: "Voir l’intervention",
doneBackToRequest: "Terminé · Retour à la demande",
doneBackToAsset: "Terminé · Retour à l'actif",
doneBackToJobs: "Terminé · Retour aux interventions",
doneOpenJob: "Terminé · Ouvrir l’intervention",
assignToTeamMemberTitle: "Attribuer à un membre de l'équipe",
teamHintNoTeamAsset: "Cet actif n'est pas lié à une équipe – via une affectation personnelle. Vous pouvez vous attribuer l'intervention.",
teamHintNoTeamJob: "Aucune équipe n'est définie sur cette intervention – affectation personnelle. Vous pouvez vous attribuer l'intervention.",
teamHintUsingTeam: "Utilisation de l'équipe qui gère cette intervention ou cet actif : {{name}}",
teamHintUsingWorkspaceTeam: "Utilisation de l'équipe de l'espace de travail liée à cette intervention ou à cet actif.",
loadingTeamMembers: "Chargement des membres de l’équipe…",
retry: "Réessayer",
noTeamMembersTitle: "Personne d’autre dans l’équipe",
noTeamMembersBody: "Ajoutez un coéquipier pour lui attribuer du travail, ou attribuez-le-vous.",
refresh: "Actualiser",
unnamedMember: "Membre sans nom",
youSuffix: " (Vous)",
scheduleJobsTogetherTitle: "Planifier {{count}} interventions ensemble",
planHandoffDateTitle: "Quand sera-t-elle faite ?",
scheduleTogetherText: "La même date, heure et durée estimée seront appliquées à chaque intervention éligible de ce lot.",
planHandoffDateText: "Choisissez le jour et l’heure de l’intervention.",
dateLabel: "Date",
timeLabel: "Heure",
estimatedDurationLabel: "Durée estimée",
cancel: "Annuler",
saveForJobs: "Enregistrer pour les {{count}} interventions",
saveDate: "Enregistrer la date",
chooseContractorsForQuotes: "Choisissez des entrepreneurs pour les devis",
assignToContractorTitle: "Attribuer à l'entrepreneur",
addContractor: "Ajouter un entrepreneur",
error: "Un problème est survenu",
failedApplyWorkPathAll: "Toutes les interventions n’ont pas été modifiées. Vérifiez votre connexion et réessayez.",
failedUpdateWorkPath: "Le choix n’a pas été enregistré. Vérifiez votre connexion et réessayez.",
failedAssign: "L’intervention n’a pas été attribuée. Vérifiez votre connexion et réessayez.",
failedReleaseFollowUp: "L’intervention de suivi n’a pas été approuvée. Vérifiez votre connexion et réessayez.",
failedScheduleJobsTogether: "Les dates n’ont pas été enregistrées. Vérifiez votre connexion et réessayez.",
failedSchedule: "La date n’a pas été enregistrée. Vérifiez votre connexion et réessayez.",
noTeamTitle: "Aucune équipe pour cette intervention",
noTeamBody: "Impossible de savoir à quelle équipe appartient cette intervention ; le prestataire n’a pas été invité. Vérifiez votre connexion et réessayez.",
assignedTitle: "Attribué, mais l’e-mail n’est pas parti",
assignedInviteFailedBody: "L’intervention lui est attribuée, mais l’e-mail d’invitation n’a pas pu être envoyé. Prévenez la personne vous-même.",
plannedDateRequiredTitle: "Date prévue requise",
plannedDateRequiredBody: "Choisissez une date planifiée avant d'enregistrer.",
nothingToScheduleTitle: "Rien à programmer",
nothingToScheduleBody: "Aucune intervention de ce lot n'est encore prête à être planifiée.",
mustBeAcceptedError: "L’intervention doit être acceptée avant de choisir une date.",
},
updates: {
  audienceEveryone: "Tous les participants",
  audienceTeam: "Mon équipe seulement",
  failedToPostUpdate: "La mise à jour n’a pas été publiée. Vérifiez votre connexion et réessayez.",
  failedToSend: "Votre mise à jour n’a pas été envoyée. Vérifiez votre connexion et réessayez.",
  quickPosted: "Mise à jour publiée. Elle apparaît dans l’activité de l’intervention.",
  quick: {
    follow_up_required: {
      note: "Une intervention de suivi est nécessaire.",
      label: "Intervention de suivi nécessaire",
    },
    completed_successfully: {
      note: "Le travail est terminé.",
      label: "Travail terminé",
    },
    additional_issue_found: {
      note: "Un autre problème a été trouvé pendant le travail.",
      label: "Autre problème trouvé",
    },
    awaiting_access: {
      note: "Impossible de continuer : en attente d’accès au site.",
      label: "En attente d’accès",
    },
    awaiting_parts: {
      note: "En attente de pièces pour continuer le travail.",
      label: "En attente de pièces",
    },
    work_in_progress: {
      note: "Travail en cours.",
      label: "Travail en cours",
    },
    arrived_on_site: {
      note: "Arrivé sur place.",
      label: "Arrivé sur place",
    },
  },
pageTitle: "Mises à jour",
jobFallback: "Intervention",
suggestedUpdateTitle: "Mise à jour suggérée",
accept: "Accepter",
expandedUpdate: "Mise à jour développée",
improvedUpdate: "Mise à jour améliorée",
unableToExpandNote: "Impossible de développer la note",
unableToImproveNote: "Impossible d'améliorer la note",
reviewGeneratedWording: "Vérifiez le libellé généré avant de l'appliquer à la mise à jour.",
photoAccessRequiredTitle: "Accès aux photos requis",
photoAccessRequiredBody: "Autoriser l’accès à la photothèque pour joindre une image.",
photoNotSavedTitle: "La photo n'a pas été enregistrée",
photoNotSavedFallback: "Impossible d'enregistrer cette photo sur l'appareil.",
activityLoadErrorTitle: "L’activité n’a pas pu être chargée. Réessayez.",
tryAgain: "Réessayer",
loadingActivity: "Chargement de l’activité",
emptyActivity: "Aucune activité pour l'instant. Les mises à jour, les commentaires, les affectations et les changements de statut apparaîtront ici.",
internalBadge: "Interne",
savedOnThisDevice: "Enregistré sur cet appareil",
showingRecentUpdates: "Affichage des 100 mises à jour enregistrées les plus récentes.",
showingSavedActivity: "Affichage de l'activité enregistrée.",
lastRefreshed: "Dernière actualisation {{date}}. Les photos peuvent nécessiter une connexion.",
refreshActivity: "Actualiser l'activité",
refreshing: "Actualisation…",
quickUpdates: "Mises à jour rapides",
attachPhoto: "Joindre une photo",
startUpdatePlaceholder: "Rédigez une mise à jour…",
jobUpdateLabel: "Mise à jour de l'intervention",
internalToggleOn: "Seule votre équipe voit cette note, pas le prestataire. Touchez pour la montrer à tous.",
internalToggleOff: "Tous les participants voient cette note. Touchez pour la réserver à votre équipe.",
sendUpdate: "Envoyer la mise à jour",
improving: "Amélioration...",
improveNote: "Améliorer la note",
expanding: "Ajout de détails…",
expandNote: "Détailler avec l’IA",
aiCleanup: "Amélioration par l’IA",
connectOnceHint: "Connectez-vous une fois pour ouvrir cet espace de travail avant d'enregistrer les mises à jour.",
openingWorkspace: "Ouverture de votre espace de travail…",
updatesSavedOnDevice_one: "{{count}} mise à jour enregistrée sur cet appareil.",
updatesSavedOnDevice_other: "{{count}} mises à jour enregistrées sur cet appareil.",
photosSavedOnDevice_one: "{{count}} photo enregistrée sur cet appareil.",
photosSavedOnDevice_other: "{{count}} photos enregistrées sur cet appareil.",
syncNeedsAttention: "La synchronisation nécessite votre attention.",
waitingToSynchronize: "En attente de synchronisation.",
reviewSynchronization: "Vérifier la synchronisation",
syncFailed: "Non envoyé. Vérifiez votre connexion et réessayez.",
couldNotSyncActivity: "Impossible de synchroniser l'activité de l'intervention.",
jobPhoto: "Photo de l'intervention",
updatesSavedOnDevice_many: "{{count}} de mises à jour enregistrées sur cet appareil.",
photosSavedOnDevice_many: "{{count}} de photos enregistrées sur cet appareil.",
},
checkRunner: {
jobStarted: "Intervention démarrée. Touchez Terminer quand le travail est fait.",
couldNotStartTitle: "Impossible de démarrer l'intervention",
tryAgain: "Veuillez réessayer.",
checkFallbackTitle: "Vérification",
stepWord_one: "étape",
stepWord_other: "étapes",
jobStartsWhenDone: "L’intervention démarre une fois ce contrôle terminé",
finishPrecheckAndStart: "Terminer la vérification préalable et démarrer l'intervention",
doneBackToJob: "Terminé — retour à l'intervention",
stepWord_many: "d’étapes",
},
quotes: {
inclTax: "TTC",
declinedLine: "{{name}} a refusé : {{reason}}",
pageTitle: "Comparez les devis",
inviteOnly: "Sur invitation uniquement",
contractorFallback: "Prestataire",
durationNotProvided: "Durée non renseignée",
priceDeltaVsLowest: "+ {{amount}} par rapport au plus bas",
durationDeltaVsFastest: "+ {{duration}} contre le plus rapide",
compareQuotesAction: "Comparez les devis",
recommendOne: "Recommander un devis",
jobTitleFallback: "Demande de devis",
jobNotFound: "Intervention introuvable.",
awardQuoteConfirmTitle: "Attribuer à {{name}} ?",
priceDurationLine: "{{price}} | {{duration}}",
aiRecommendationFavors: "La recommandation de l’IA privilégie actuellement ce devis.",
awardConsequence: "L'intervention revient tout de suite à {{name}}. Tous les autres devis sont refusés et ces entrepreneurs sont informés.",
awarded: "Devis accepté. L'intervention est désormais confiée à {{name}}, et les autres entrepreneurs qui ont envoyé un devis ont été informés.",
acceptFailedTitle: "Impossible d'accepter le devis",
acceptFailedBody: "Le devis n'a pas été accepté. Actualisez cette page pour voir s'il a déjà été décidé, puis réessayez.",
rejectFailedTitle: "Impossible de refuser le devis",
rejectFailedBody: "Le devis n'a pas été refusé. Actualisez cette page, puis réessayez.",
acceptQuoteFallbackMessage: "Accepter ce devis et mettre à jour l'intervention avec l'entrepreneur, le coût prévu et la durée prévue ?",
awardQuoteTitle: "Attribuer le devis",
cancel: "Annuler",
award: "Attribuer",
error: "Erreur",
failedAcceptQuote: "Échec de l'acceptation du devis",
rejectQuoteConfirmTitle: "Rejeter le devis de {{name}} ?",
decisionTrackedNotify: "Cette décision est suivie et peut notifier l'entrepreneur.",
rejectQuoteFallbackMessage: "Rejeter ce devis ? Le prestataire peut être prévenu et cette décision est enregistrée.",
rejectQuoteTitle: "Rejeter le devis",
reject: "Refuser",
failedRejectQuote: "Échec du rejet du devis",
aiQuoteIntelligenceTitle: "Analyse des devis par l’IA",
aiGroundedHint: "Basé uniquement sur les champs des devis soumis. Vérifiez avant de prendre une décision finale.",
generatingAiInsights: "Génération de l’analyse IA…",
refreshAiInsights: "Actualiser l’analyse IA",
generateAiInsights: "Générer l’analyse IA",
lastUpdated: "Dernière mise à jour : {{date}}",
comparisonInsightsLabel: "Informations comparatives",
notableDifferencesLabel: "Différences notables",
bestValueSuggestionLabel: "Suggestion de meilleure valeur (assistance)",
suggestedQuote: "Devis suggéré : {{name}}",
noSingleQuoteSuggested: "Aucun devis en particulier n’est suggéré pour l’instant (éléments insuffisants).",
cautionLine: "Attention : {{caution}}",
confidenceLine: "Confiance : {{confidence}}",
unableToGenerateAiInsights: "Impossible de générer l’analyse IA.",
comparisonSummaryLabel: "Comparer les devis",
priceRangeLine: "Gamme de prix : {{low}} à {{high}}",
priceDataUnavailable: "Les données de prix ne sont pas disponibles.",
durationRangeLine: "Plage de durée : {{fast}} à {{slow}}",
durationDataUnavailable: "Données de durée indisponibles.",
jobContextLabel: "Contexte de l'intervention",
assetLine: "Actif : {{name}}",
noLinkedAsset: "Aucun actif lié",
locationLine: "Emplacement : {{value}}",
categoryLine: "Catégorie : {{value}}",
urgencyLine: "Urgence : {{value}}",
requestProgressLabel: "Avancement de la demande",
inviteSummaryLine: "Invités : {{invited}} · Soumis : {{submitted}} · Refusés : {{declined}}",
inviteSummaryPendingSuffix: " · {{pending}} en attente",
responseDeadlineLine: "Délai de réponse : {{date}}",
targetWindowLine: "Fenêtre cible : {{start}} à {{end}}",
budgetLine: "Budget : {{value}}",
scopeLabel: "Périmètre",
noOpenQuotesTitle: "Aucun devis en attente de décision",
noOpenQuotesBody: "Les sous-traitants invités peuvent soumettre des devis. Les décisions apparaissent ici.",
allDeclinedBody: "Toutes les personnes sollicitées ont refusé. Invitez d'autres sous-traitants pour obtenir un prix.",
headerContractor: "Prestataire",
headerPrice: "Prix",
headerDuration: "Durée",
headerAvailability: "Disponibilité",
headerScopeExclusions: "Périmètre / exclusions",
headerAiSummary: "Résumé IA",
scopeResponseMissing: "Réponse sur le périmètre manquante",
missingLine: "Manquant : {{items}}",
completeResponse: "Réponse complète",
bestPriceChip: "Meilleur prix",
fastestChip: "Le plus rapide",
aiRecommendedChip: "Recommandé par l’IA",
runAiInsightsToGenerateSummary: "Lancez l’analyse IA pour générer un résumé.",
acceptedQuoteLabel: "Devis accepté",
rejectedQuotesLabel: "Devis rejetés",
reasonLine: "Raison : {{reason}}",
selectQuoteTitle: "Sélectionnez un devis",
selectQuoteBody: "Choisissez une ligne de devis pour voir les détails, l’analyse IA et les décisions d’attribution.",
rejecting: "Rejet...",
awarding: "Attribution…",
awardQuoteAction: "Attribuer le devis",
openJob: "Ouvrir l'intervention",
bestPriceAndFastest: "Meilleur prix et plus rapide",
fastestDuration: "Durée la plus rapide",
submittedQuoteStatus: "Devis soumis",
applyingDecision: "Application de la décision…",
aiIntelligenceLabel: "Analyse IA",
includedLabel: "Inclus",
excludedLabel: "Exclus",
caveatsLabel: "Mises en garde",
aiSummaryIncludedLine: "Inclus : {{items}}",
aiSummaryExcludedLine: "Exclus : {{items}}",
aiSummaryCaveatsLine: "Mises en garde : {{items}}",
recommendationLabel: "Recommandation",
recommendationValue: "{{name}} ({{confidence}})",
noneFallback: "Aucun",
whatsIncludedHeading: "Ce qui est inclus",
notProvidedFallback: "Non fourni",
materialsLabel: "Matériaux",
notIncludedFallback: "Non inclus",
warrantyLabel: "Garantie",
availabilityRangeArrow: "{{start}} → {{end}}",
exclusionsLabel: "Exclusions",
evidenceLabel: "Preuve",
missingInfoLine: "Informations manquantes : {{items}}",
linkedContextHeading: "Contexte lié",
jobLabelKv: "Intervention",
assetLabelKv: "Actif",
noScopeProvided: "Aucun périmètre fourni",
requestNotesLabel: "Notes de la demande",
noNotesProvided: "Aucune note fournie",
inviteMoreContractors: "Inviter plus d'entrepreneurs",
scopeResponseLine: "Ce qui est couvert : {{value}}",
durationLine: "Durée : {{value}}",
availabilityToLine: "Disponibilité : {{start}} à {{end}}",
exclusionsLine: "Comprend : {{value}}",
evidenceLine: "Preuve : {{value}}",
warrantyLine: "Garantie : {{value}}",
attachmentsLine: "Pièces jointes : {{count}}",
aiSummaryLabel: "Résumé IA",
fastestDurationChip: "Durée la plus rapide",
acceptQuote: "Accepter le devis",
},
share: {
  relationshipChangeA11y: "Modifier son lien avec le bien",
  relationshipChange: "Modifier",
  relationship: "Son lien : {{role}}",
  openJob: "Ouvrir l’intervention",
  editContactDetails: "Modifier les coordonnées",
  copyLink: "Copier le lien",
  emailNotSent: "Partagé, mais l’e-mail n’est pas parti. Copiez le lien pour l’envoyer vous-même.",
  checkDetails: "Vérifiez le contact, le rôle et l’e-mail, puis touchez à nouveau Envoyer.",
  emailRequired: "Saisissez son adresse e-mail. Le lien du rapport y sera envoyé.",
  roleRequired: "Indiquez qui est cette personne, par exemple Demandeur.",
  addEmail: "Ajouter l’e-mail",
  chooseRole: "Choisir le rôle",
  chooseContact: "Choisir un contact",
jobFallback: "Intervention",
couldNotLoadReport: "Impossible de charger ce rapport. Essayer à nouveau.",
greetingDefault: "Bonjour,\n\nVeuillez trouver le rapport d'achèvement de l'intervention pour {{name}}. Le travail est terminé et documenté pour vos dossiers.\n\nMerci.",
loadingReport: "Chargement du rapport",
tryAgain: "Réessayer",
jobNotFound: "Intervention introuvable",
onlyOwnerCanShare: "Seul le propriétaire de l'intervention ou un membre de l'équipe de l'actif peut partager le rapport d'achèvement.",
goBack: "Retour",
completeAndVerifyFirst: "Terminez cette intervention avant de partager son rapport.",
error: "Erreur",
jobNotFoundBody: "Intervention introuvable.",
notReadyTitle: "Pas prêt",
notReadyBody: "Terminez cette intervention avant de partager son rapport.",
checkPhoneTitle: "Vérifiez le numéro de téléphone",
checkPhoneBody: "Saisissez un numéro valide pour le pays sélectionné, ou laissez le téléphone vide.",
resent: "Renvoyé",
sent: "Envoyé",
resentBody: "Rapport renvoyé. La personne reçoit un nouvel e-mail avec le lien.",
sentBody: "Rapport envoyé. La personne reçoit un e-mail avec un lien pour examiner le travail.",
emailErrorLine: "\n\nErreur : {{error}}",
emailFailedBody: "Impossible d’envoyer l’e-mail. Partagez manuellement le lien d’examen :\n{{link}}{{errorLine}}",
shareCreatedTitle: "Partage créé",
shareCreatedBody: "Partager ce lien :\n{{link}}",
failedToCreateShare: "Le rapport n’a pas été partagé. Vérifiez votre connexion et réessayez.",
devLinkWarning: "Les liens de partage utilisent localhost et ne fonctionneront pas pour les destinataires. Ajoutez EXPO_PUBLIC_WEB_APP_URL à votre .env (l’URL de votre application déployée) et redémarrez.",
prodLinkWarning: "Aucun lien Web partageable n'est encore configuré pour cet espace de travail. Les destinataires risquent de ne pas pouvoir ouvrir le lien du rapport. Veuillez contacter votre administrateur.",
shareToLabel: "Envoyer à",
shareToHint: "Appuyez sur Sélectionner le contact et choisissez la personne. Les personnes à qui vous l'avez déjà envoyé sont en haut.",
whoCanOpen: "Seule cette personne peut ouvrir le rapport. Le lien de son e-mail la connecte directement. Toute autre personne qui reçoit le lien peut seulement vous demander l'accès.",
changeContact: "Changer le contact",
selectContact: "Sélectionner le contact",
contactFallback: "Contact",
noEmailOrPhone: "Pas d'e-mail ni de téléphone",
shareToContactTitle: "Envoyer à",
howToSendLabel: "Comment envoyer",
shareViaLabel: "Partager via",
emailMethodLabel: "E-mail",
roleLabel: "Rôle *",
recipientNameLabel: "Son nom (facultatif)",
recipientNamePlaceholder: "par ex. John Smith",
recipientEmailLabel: "Son e-mail *",
recipientEmailAria: "Son e-mail (obligatoire)",
recipientEmailPlaceholder: "client@example.com",
phoneOptionalLabel: "Téléphone (facultatif)",
shareStatusLabel: "Déjà envoyé",
firstSharedLine: "Déjà envoyé le {{date}}",
lastResharedLine: "Envoyé à nouveau le {{date}}",
noResponseByDeadline: "Pas de réponse à la date prévue. Appuyez sur Envoyer à nouveau pour relancer.",
responseDeadlineLabel: "Répondre avant le (facultatif)",
selectDatePlaceholder: "Choisir une date",
messageOptionalLabel: "Message (facultatif)",
messagePlaceholder: "Ajouter une note pour le destinataire...",
actualCostOnReport: "Coût réel sur le rapport : {{amount}}",
sending: "Envoi…",
resend: "Envoyer à nouveau",
send: "Envoyer le rapport",
cancel: "Annuler",
couldNotShareReportTitle: "Impossible de partager le rapport",
sharingFailedFallback: "Échec du partage. Vérifiez votre connexion et réessayez.",
},
requestQuotes: {
includedItemsHeading: "Éléments inclus :",
excludedOrAssumptionsHeading: "Exclus ou hypothèses :",
clarificationQuestionsHeading: "Questions de clarification :",
addNotesFirstTitle: "Ajouter des notes en premier",
addNotesFirstBody: "Tapez ou dictez des notes, puis utilisez l'IA pour les réécrire.",
couldNotRewriteNotesTitle: "Impossible de réécrire les notes",
tryAgain: "Veuillez réessayer.",
applyAiScopeDraftTitle: "Appliquer le brouillon de périmètre de l’IA",
applyAiScopeDraftBody: "Vous avez déjà un texte de périmètre. Le remplacer ou ajouter le brouillon de l’IA ?",
cancel: "Annuler",
append: "Ajouter",
replace: "Remplacer",
unableToGenerateScopeTitle: "Impossible de générer le périmètre",
selectContractorsTitle: "Sélectionnez les entrepreneurs",
selectContractorsBody: "Choisissez au moins un entrepreneur à inviter.",
quoteRequestSent_one: "Demande de devis envoyée à {{count}} entrepreneur. Vous serez prévenu à l'arrivée des devis. Comparez-les depuis cette intervention.",
quoteRequestSent_other: "Demande de devis envoyée à {{count}} entrepreneurs. Vous serez prévenu à l'arrivée des devis. Comparez-les depuis cette intervention.",
error: "Erreur",
failedToSendQuoteRequest: "Échec de l'envoi de la demande de devis",
sendFailedTitle: "Impossible d'envoyer la demande de devis",
sendFailedBody: "La demande de devis n'a pas été envoyée. Vos saisies sont conservées : réessayez dans un instant.",
noEmailNote: "Pas d'e-mail : cette personne ne recevra rien. Ajoutez-en un sur sa fiche contact.",
jobNotFound: "Intervention introuvable.",
notPrivateQuotesBody: "Cette intervention est prévue pour une seule personne. Pour demander un prix à plusieurs entrepreneurs, touchez Demander des devis à la place.",
notPrivateQuotesLockedBody: "Cette intervention est prévue pour une seule personne et ne peut plus être soumise à devis.",
switchToQuotes: "Demander des devis à la place",
switchingToQuotes: "Changement…",
switchFailedTitle: "Impossible de passer aux devis",
switchFailedBody: "L'intervention n'a pas été modifiée. Réessayez dans un instant.",
backToJob: "Retour à l'intervention",
goBack: "Retour",
jobTitleFallback: "Demande de devis",
pageTitle: "Demander des devis",
inviteOnly: "Sur invitation uniquement",
inviteTrustedHint: "Invitez des entrepreneurs de confiance de votre répertoire. Ceci n'est pas une liste publique.",
scopeDescriptionLabel: "Périmètre / description",
scopeDescriptionPlaceholder: "Quel travail est nécessaire ?",
generatingScope: "Génération...",
aiScope: "Rédiger avec l'IA",
notesOptionalLabel: "Notes (facultatif)",
notesOptionalPlaceholder: "Contexte supplémentaire pour les sous-traitants",
rewriting: "Réécriture...",
rewrite: "Réécrire",
aiScopeDraftDetailsTitle: "Détails du brouillon rédigé par l'IA",
includedLine: "Inclus : {{items}}",
excludedLine: "Exclus : {{items}}",
questionsLine: "Questions : {{items}}",
responseDeadlineLabel: "Délai de réponse (facultatif)",
respondByPlaceholder: "Avant quelle date doivent-ils répondre ?",
responseTimeLabel: "Heure limite de réponse (facultatif)",
selectTimePlaceholder: "Sélectionnez l'heure",
targetStartLabel: "Démarrage cible (facultatif)",
earliestStartPlaceholder: "Date de début la plus proche",
targetEndLabel: "Fin souhaitée (facultatif)",
latestEndPlaceholder: "Dernière date de fin",
estimatedBudgetLabel: "Budget estimé (facultatif)",
photosLabel: "Photos (facultatif, 3 maximum)",
selectContractorsLabel: "Sélectionnez les entrepreneurs à inviter *",
selectContractorsHint: "Recherchez vos contacts et filtrez éventuellement par compétence ou par domaine d'activité. Personne n'est présélectionné pour vous.",
requiredSkillsLabel: "Compétences requises",
addOrChangeContractors: "Ajouter ou modifier des entrepreneurs",
chooseContractors: "Choisir les entrepreneurs",
selectedCount: "Sélectionné · {{count}}",
declinedToQuote: "A décliné la demande de devis",
quoteSubmitted: "Devis soumis",
alreadyInvited: "Déjà invité — en attente de leur réponse",
removeContact: "Retirer {{name}}",
noContractorsSelected: "Aucun entrepreneur sélectionné pour l'instant.",
creating: "Création en cours…",
sending: "Envoi…",
everyoneAlreadyInvited: "Toutes les personnes sélectionnées sont déjà invitées",
sendToMore_one: "Envoyer à {{count}} entrepreneur de plus",
sendToMore_other: "Envoyer à {{count}} entrepreneurs de plus",
sendTo_one: "Envoyer à {{count}} entrepreneur",
sendTo_other: "Envoyer à {{count}} entrepreneurs",
chooseContractorsForQuotesTitle: "Choisissez des entrepreneurs pour les devis",
addContractor: "Ajouter un entrepreneur",
quoteRequestSent_many: "Demande de devis envoyée à {{count}} d’entrepreneurs. Vous serez prévenu à l'arrivée des devis. Comparez-les depuis cette intervention.",
sendToMore_many: "Envoyer à {{count}} d’entrepreneurs de plus",
sendTo_many: "Envoyer à {{count}} d’entrepreneurs",
},
quoteInvite: {
brief: {
forClient: "Pour {{name}}",
replyBy: "Répondre avant le {{date}}",
budget: "Budget prévu {{amount}}",
starts: "Début {{date}}",
finishBy: "Terminer avant le {{date}}",
due: "Échéance {{date}}",
whatTheyNeed: "Ce dont ils ont besoin",
where: "Où",
route: "Itinéraire dans Google Maps",
photos: "Leurs photos",
},
form: {
title: "Votre devis",
intro: "Dites ce que couvre votre prix, puis le total. Vous vérifiez tout avant l’envoi.",
included: "Ce qui est inclus",
labourOnly: "Main-d’œuvre seule",
labourAndMaterials: "Main-d’œuvre et matériaux",
coversLabel: "Ce que couvre votre prix",
coversPlaceholder: "ex. Fournir et installer un canapé 3 places neuf et enlever l’ancien",
total: "Prix total",
totalTax: "toutes taxes comprises",
totalHelp: "Incluez la TVA et toute autre taxe : c’est ce que paie le client.",
warranty: "Garantie",
warrantyNone: "Aucune",
warranty3: "3 mois",
warranty6: "6 mois",
warranty12: "12 mois",
warrantyPlaceholder: "Ou la vôtre, ex. 2 ans sur les pièces",
takes: "Durée des travaux",
when: "Quand vous pourriez intervenir",
earliest: "Début au plus tôt",
finishBy: "Fin au plus tard",
files: "Photos ou documents",
note: "Note pour le client (facultatif)",
notePlaceholder: "Tout ce qu’il doit savoir d’autre",
review: "Vérifier et envoyer",
needPrice: "Ajoutez votre prix total pour continuer.",
cantQuote: "Je ne peux pas chiffrer ce travail",
},
review: {
title: "Envoyer ce devis ?",
subtitle: "À {{name}}",
subtitleNoName: "Au client",
total: "Total, toutes taxes comprises",
includes: "Comprend",
warranty: "Garantie",
takes: "Durée",
available: "Disponible",
files: "Pièces jointes",
filesCount: "{{n}} jointe(s)",
note: "Remarque",
send: "Envoyer le devis",
change: "Modifier quelque chose",
from: "À partir du {{date}}",
until: "Jusqu’au {{date}}",
},
declineSheet: {
title: "Impossible de chiffrer ce travail ?",
subtitle: "Dites à {{name}} pourquoi. Votre motif lui est montré.",
subtitleNoName: "Dites au client pourquoi. Votre motif lui est montré.",
reasonLabel: "Pourquoi ?",
no_availability: "Pas de disponibilité",
outside_area: "Hors de ma zone",
not_my_work: "Pas mon type de travail",
budget_or_timing: "Le budget ou les délais ne conviennent pas",
other: "Autre chose",
noteLabel: "Quelque chose à ajouter (facultatif)",
noteLabelOther: "Dites-leur pourquoi",
notePlaceholder: "ex. Complet jusqu’en décembre",
send: "Refuser de chiffrer",
chooseReason: "Choisissez un motif pour continuer.",
},
jobFallback: "Intervention",
loadFailed: "Cette demande de devis ne s'est pas chargée. Vérifiez votre connexion et réessayez.",
contextLoadFailed: "Les détails de cette demande de devis ne se sont pas chargés. Vérifiez votre connexion et réessayez.",
notFound: "Nous ne trouvons pas cette demande de devis, ou elle a déjà reçu une réponse.",
alreadySent: "Vous avez déjà envoyé un devis pour cette demande.",
alreadyDeclined: "Vous avez décliné cette demande de devis.",
closedBody: "Cette demande de devis est close. Le client a choisi un devis, le délai est passé ou la demande a été retirée.",
deadlinePassed: "Le délai de cette demande était le {{date}} : le client ne peut plus accepter de devis.",
addNotesFirstTitle: "Ajoutez d'abord des notes",
addNotesFirstBody: "Saisissez ou dictez des notes, puis touchez Réécrire.",
rewriteFailedTitle: "Impossible de réécrire les notes",
rewriteFailedBody: "Veuillez réessayer.",
enterPriceTitle: "Indiquez votre prix",
enterPriceBody: "Saisissez le prix total de ce travail, puis touchez Envoyer le devis.",
durationTitle: "Vérifiez la durée estimée",
durationBody: "Saisissez un nombre supérieur à zéro, ou laissez vide.",
durationPlaceholder: "ex. 2",
unit: {
hours: "Heures",
days: "Jours",
weeks: "Semaines",
},
dictate: "Dicter",
stop: "Arrêter",
rewrite: "Réécrire",
rewriting: "Réécriture…",
submit: "Envoyer le devis",
submitting: "Envoi…",
sent: "Devis envoyé. Nous vous préviendrons si le client l'accepte.",
sendFailedTitle: "Impossible d'envoyer votre devis",
sendFailedBody: "Votre devis n'a pas été envoyé. Vos saisies sont conservées : réessayez dans un instant.",
offlineSend: "Vous êtes hors ligne. Votre devis est conservé sur cet appareil : envoyez-le une fois reconnecté.",
declineConfirmTitle: "Décliner cette demande ?",
declineConfirmBody: "Le client sera informé que vous ne ferez pas de devis.",
cancel: "Annuler",
decline: "Décliner",
declined: "Demande déclinée. Le client a été informé.",
declineFailedTitle: "Impossible de décliner",
declineFailedBody: "La demande n'a pas été déclinée. Réessayez dans un instant.",
offlineDecline: "Vous êtes hors ligne. Déclinez la demande une fois reconnecté.",
},
contractorNotTold: {
title: "Personne n'a été prévenu",
body: "{{name}} est affecté mais n'a pas d'e-mail, il n'a donc pas été prévenu. Ajoutez son e-mail, puis affectez-le à nouveau.",
},
created: {
  assignNow_many: "Les attribuer maintenant",
  assignNow_other: "Les attribuer maintenant",
  assignNow_one: "L’attribuer maintenant",
  subtitleAssignedTo: "Dans Travail et attribué à {{names}}.",
  subtitleAssigned: "Dans Travail et attribué.",
  changeWho: "Changer qui s’en charge",
  subtitleSolo_many: "Elles sont dans Travail et vous sont attribuées.",
  subtitleSolo_other: "Elles sont dans Travail et vous sont attribuées.",
  subtitleSolo_one: "Elle est dans Travail et vous est attribuée.",
  subtitle_many: "Elles sont dans Travail, sans personne attribuée. Personne n’a encore été prévenu.",
  subtitle_other: "Elles sont dans Travail, sans personne attribuée. Personne n’a encore été prévenu.",
  subtitle_one: "Elle est dans Travail, sans personne attribuée. Personne n’a encore été prévenu.",
title_one: "{{count}} intervention créée",
title_other: "{{count}} interventions créées",
subtitle: "Elles sont dans Travail, sans personne attribuée. Personne n’a encore été prévenu.",
listTitle: "Interventions créées",
jobLink: "Intervention {{shortId}}",
backToRequest: "Retour à la demande",
backToAsset: "Retour à l'actif",
backToJobs: "Retour aux interventions",
technicalTitle: "Détails techniques",
technicalSummary: "Identifiants complets des interventions et de l'actif pour le support ou les intégrations.",
technicalJobIds: "ID des interventions",
technicalAssetId: "ID d'actif",
showMore: "Afficher plus",
showLess: "Afficher moins",
title_many: "{{count}} d’interventions créées",
},
jobTags: {
urgency: {
low: "Priorité basse",
medium: "Priorité moyenne",
high: "Priorité haute",
urgent: "Urgent",
critical: "Critique",
},
visibility: {
private: "Privé",
team: "Équipe",
public: "Visible de tous",
},
},
assigneeSuggestion: {
similarCompleted_one: "{{count}} intervention similaire terminée",
similarCompleted_many: "{{count}} d’interventions similaires terminées",
similarCompleted_other: "{{count}} interventions similaires terminées",
skillMatches_one: "{{count}} intervention correspondant aux compétences requises",
skillMatches_many: "{{count}} d’interventions correspondant aux compétences requises",
skillMatches_other: "{{count}} interventions correspondant aux compétences requises",
completedOnAsset_one: "{{count}} terminée sur cet actif",
completedOnAsset_many: "{{count}} terminées sur cet actif",
completedOnAsset_other: "{{count}} terminées sur cet actif",
activeAssignments_one: "{{count}} attribution active",
activeAssignments_many: "{{count}} d’attributions actives",
activeAssignments_other: "{{count}} attributions actives",
overdue_one: "{{count}} en retard",
overdue_many: "{{count}} en retard",
overdue_other: "{{count}} en retard",
separator: ", ",
},
quoteComparisonCopy: {
materialsIncluded: "Matériaux inclus ; aucune exclusion indiquée",
materialsExcluded: "Matériaux exclus : {{details}}",
materialsMissing: "Matériaux exclus ; détails manquants",
evidenceAttachments_one: "{{count}} preuve jointe",
evidenceAttachments_many: "{{count}} de preuves jointes",
evidenceAttachments_other: "{{count}} preuves jointes",
noEvidence: "Aucune preuve jointe",
missingScope: "ce que couvre le prix",
missingTiming: "délais",
durationHours_one: "{{count}} heure",
durationHours_many: "{{count}} d’heures",
durationHours_other: "{{count}} heures",
durationDays_one: "{{count}} jour",
durationDays_many: "{{count}} de jours",
durationDays_other: "{{count}} jours",
durationWeeks_one: "{{count}} semaine",
durationWeeks_many: "{{count}} de semaines",
durationWeeks_other: "{{count}} semaines",
},
};
